import type { MessageKey } from './index';

// Spanish translations. Keys mirror ./index; TypeScript enforces completeness.
export const es: Record<MessageKey, string> = {
  'common.cancel': 'Cancelar',
  'common.stepperHint':
    'Haz clic para avanzar un paso (Shift ×10). Mantén pulsado y arrastra arriba o abajo',
  'common.confirm': 'Confirmar',
  'common.copied': 'Copiado',
  'common.create': 'Crear',
  'common.delete': 'Eliminar',
  'renders.deleteSelected': 'Eliminar seleccionadas ({n})',
  'renders.deleteAll': 'Eliminar todas',
  'renders.selectAll': 'Seleccionar todas',
  'renders.deleteTitle': '¿Eliminar esta generación?',
  'renders.deleteSelectedTitle': '¿Eliminar {n} generaciones seleccionadas?',
  'renders.deleteAllTitle': '¿Eliminar todas las generaciones?',
  'renders.deleteFilteredTitle': '¿Eliminar todas las generaciones que coinciden con los filtros?',
  'renders.deleteText':
    'Los archivos se eliminan para siempre. Las generaciones ya usadas del plan no se devuelven.',
  'renders.deleted': 'Eliminadas: {n}',
  'renders.skippedRunning': 'Aún en proceso, no eliminadas: {n}',
  'batch.delete': 'Eliminar ejecución',
  'batch.deleteTitle': '¿Eliminar esta ejecución y todas sus generaciones?',
  'batch.deleteText':
    'Se eliminan todas las imágenes de la ejecución y su ZIP. Las generaciones ya usadas del plan no se devuelven.',
  'automation.deleteWithRenders': 'Eliminar también todos los banners generados',
  'err.batchRunning': 'La ejecución sigue en curso: elimínala cuando termine.',
  'err.renderRunning': 'La generación sigue en curso: elimínala cuando termine.',
  'audit.renders.deleted': 'Generaciones eliminadas:',
  'common.download': 'Descargar',
  'common.edit': 'Editar',
  'common.error': 'Error',
  'common.height': 'Alto',
  'common.width': 'Ancho',
  'common.import': 'Importar',
  'nav.admin': 'Administración',
  'billing.testMode': 'Modo de prueba de superadministrador',
  'billing.testModeHint':
    'Cambia el plan de este espacio de trabajo al instante y sin pago, para comprobar los límites.',
  'billing.manual': 'manual',
  'admin.title': 'Administración',
  'admin.description':
    'Todos los usuarios y espacios de trabajo de la plataforma. Solo visible para superadministradores.',
  'admin.overview': 'Resumen',
  'admin.users': 'Usuarios',
  'admin.usersHint': '+{n7} en 7 días · +{n30} en 30 días',
  'admin.active7': 'Iniciaron sesión, 7 días',
  'admin.blockedN': 'Bloqueados: {n}',
  'admin.renders30': 'Imágenes generadas, 30 días',
  'admin.rendersHint': 'Hoy {today} · fallidas {failed}',
  'admin.mrr': 'MRR (suscripciones)',
  'admin.paying': 'Espacios de trabajo de pago: {n}',
  'admin.workspacesByPlan': 'Espacios de trabajo por plan · {n}',
  'admin.ai30': 'IA, 30 días',
  'admin.aiRequests': 'solicitudes',
  'admin.aiCost': 'coste del modelo',
  'admin.search': 'Buscar por correo o nombre',
  'admin.user': 'Usuario',
  'admin.workspaces': 'Espacios de trabajo',
  'admin.workspace': 'Espacio de trabajo',
  'admin.signedUp': 'Registro',
  'admin.lastLogin': 'Último inicio de sesión',
  'admin.sessions': 'sesiones activas: {n}',
  'admin.blocked': 'bloqueado',
  'admin.block': 'Bloquear',
  'admin.unblock': 'Desbloquear',
  'admin.blockTitle': '¿Bloquear a {email}?',
  'admin.blockText':
    'Se cerrará la sesión del usuario en todas partes y no podrá iniciar sesión hasta que se desbloquee. Sus espacios de trabajo y claves de API seguirán funcionando.',
  'admin.blockedDone': 'Usuario bloqueado',
  'admin.unblockedDone': 'Usuario desbloqueado',
  'admin.signOut': 'Cerrar sesión en todas partes',
  'admin.signedOutDone': 'Sesiones cerradas',
  'admin.delete': 'Eliminar',
  'admin.deleteTitle': '¿Eliminar a {email}?',
  'admin.deleteText':
    'La cuenta se elimina para siempre junto con los espacios donde es el único miembro: plantillas, archivos y renders. Se rechaza si es propietario de un espacio compartido o tiene una suscripción de pago.',
  'admin.deletedDone': 'Usuario eliminado',
  'admin.plan': 'Plan',
  'admin.planSet': '“{name}” ahora tiene el plan {plan}',
  'admin.manual': 'manual',
  'admin.templates': 'Plantillas',
  'admin.renders30short': 'Generadas 30 d',
  'admin.storage': 'Almacenamiento',
  'admin.lastRender': 'Última generación',
  'admin.members': 'miembros: {n}',
  'common.back': 'Atrás',
  'common.next': 'Siguiente',
  'legal.privacy': 'Política de privacidad',
  'legal.terms': 'Condiciones del servicio',
  'legal.privacyLower': 'política de privacidad',
  'legal.termsLower': 'condiciones del servicio',
  'legal.and': 'y la',
  'legal.consentPrefix': 'Al registrarte, aceptas las',
  'legal.updated': 'Última actualización: {date}',
  'legal.home': 'Volver al inicio',
  'help.title': 'Ayuda y avisos legales',
  'help.support': 'Soporte',
  'help.apiDocs': 'Referencia de la API',
  'help.apiDocsHint': 'Endpoints, parámetros, ejemplos',
  'help.termsHint': 'Normas de uso del servicio',
  'help.privacyHint': 'Qué datos guardamos y por qué',
  'preview.final': 'Imagen final sin marca de agua',
  'preview.watermarkHint': 'Gratis: la vista previa con marca de agua no consume tu plan.',
  'preview.finalHint': 'Consume 1 generación de tu plan.',
  'billing.fPreviews': 'Vistas previas gratuitas con marca de agua',
  'showcase.badge': 'Editor',
  'showcase.title': 'Un editor que mantiene el diseño en orden',
  'showcase.subtitle':
    'No es solo un lienzo con coordenadas: pilas al estilo Figma, redimensionado inteligente a cualquier tamaño y espaciado preciso. Cambia el tamaño: es una generación real.',
  'showcase.render': 'Generar',
  'showcase.layers': 'Capas',
  'showcase.clickHint': 'Haz clic en una capa o cambia el tamaño',
  'showcase.layer': 'Capa',
  'showcase.apiField': 'Nombre de la capa = campo de la API y columna de la tabla',
  'showcase.stack': 'Pila (diseño automático)',
  'showcase.resize': 'Redimensionado',
  'showcase.resizeText':
    'Las capas se adaptan según sus reglas: una plantilla para todas las plataformas.',
  'showcase.altHint': 'Alt: distancias a los elementos vecinos',
  'showcase.p1Title': 'Pilas al estilo Figma',
  'showcase.p1Text':
    'Un texto largo desde la API desplaza a los elementos vecinos en lugar de superponerse.',
  'showcase.p2Title': 'Una plantilla, todos los tamaños',
  'showcase.p2Text':
    'Publicación, historia y banner a partir de un mismo diseño, con las capas adaptadas.',
  'showcase.p3Title': 'Espaciado preciso',
  'showcase.p3Text': 'Ajuste, guías y distancias a los elementos vecinos con Alt.',
  'showcase.p4Title': 'Listo para automatizar',
  'showcase.p4Text': 'Cada capa está disponible al instante en la API, las tablas y los enlaces.',
  'motionShowcase.badge': 'Animación',
  'motionShowcase.title': 'De banner estático a animación en un clic',
  'motionShowcase.subtitle':
    'Pulsa «Animar»: el título, la foto, el precio y el botón reciben cada uno su propio movimiento. Sin línea de tiempo ni fotogramas clave.',
  'motionShowcase.static': 'Estático',
  'motionShowcase.animated': 'Animado',
  'motionShowcase.formats': 'MP4 · WebM · GIF',
  'motionShowcase.hint': 'Es una generación real: cambia de estilo',
  'motionShowcase.p1Title': 'Un clic',
  'motionShowcase.p1Text':
    'El servicio detecta el título, la foto, el precio y el botón y da a cada capa su propia entrada en orden de lectura.',
  'motionShowcase.p2Title': 'Un estilo para cada tarea',
  'motionShowcase.p2Text':
    'Suave, enérgico, rebajas, cinético, elegante y más. Puedes ajustar el resultado a mano.',
  'motionShowcase.p3Title': 'Cientos de creatividades animadas',
  'motionShowcase.p3Text':
    'La misma plantilla, desde una hoja, un feed o la API, genera MP4, WebM y GIF en todos los tamaños, incluidas Stories y Reels.',
  'previewMode.title': 'Modo de vista previa',
  'previewMode.text':
    'Todas las imágenes del espacio de trabajo (API, automatizaciones, enlaces y editor) llevan marca de agua y no consumen tu cuota. Es útil mientras configuras una integración; desactívalo cuando esté lista.',
  'previewMode.on': 'El modo de vista previa está activado',
  'previewMode.off': 'El modo de vista previa está desactivado',
  'previewMode.banner':
    'Modo de vista previa: todas las imágenes llevan marca de agua y no consumen tu cuota.',
  'previewMode.manage': 'Desactivar',
  'linked.masterChip': 'Conjunto: {n} tamaños',
  'linked.sizeChip': 'Tamaño de “{name}”',
  'linked.changedN': 'modificadas: {n}',
  'linked.setTitle': 'Tamaños vinculados',
  'linked.addSize': 'Añadir un tamaño',
  'linked.addSizeHint':
    'El mismo diseño en otro tamaño. Los cambios del original llegan a todos los tamaños y los cambios a mano de un tamaño se conservan',
  'linked.addSizeTileHint': 'Historia, post, banner: los cambios se trasladan',
  'linked.resetAll': 'Restablecer todos los cambios de este tamaño',
  'linked.unlink': 'Desvincular del original',
  'linked.masterHint':
    'Los cambios en esta plantilla se aplican a todos los tamaños. Lo que se haya modificado a mano en un tamaño se conserva.',
  'linked.sizeHint':
    'Las ediciones del original llegan aquí automáticamente. Las capas modificadas aquí se marcan con un punto y no se sobrescriben.',
  'linked.layerChanged':
    'Modificada en este tamaño: las ediciones del original no la sobrescribirán',
  'linked.resetLayer': 'Restablecer',
  'linked.changesTitle': 'Cambiado en este tamaño',
  'linked.changesHint': 'Qué cambió este tamaño respecto al original y cómo restablecerlo',
  'linked.selectLayer': 'Seleccionar la capa',
  'linked.resetLayerHint': 'Dejar la capa como en el original',
  'linked.resetAdded': 'Quitar',
  'linked.resetRemoved': 'Restaurar',
  'linked.changeAdded': 'solo en este tamaño',
  'linked.changeRemoved': 'eliminada en este tamaño',
  'linked.propPosition': 'posición',
  'linked.propSize': 'tamaño',
  'linked.propRotation': 'rotación',
  'linked.propLayout': 'disposición',
  'linked.propText': 'texto',
  'linked.propFont': 'fuente',
  'linked.propColor': 'color',
  'linked.propImage': 'imagen',
  'linked.propVisibility': 'visibilidad',
  'linked.propMotion': 'animación',
  'linked.propOther': 'propiedades',
  'linked.option': 'Vincular al original',
  'linked.optionHint':
    'Los cambios del original se aplican automáticamente a este tamaño; tus ediciones en él se conservan.',
  'linked.optionPaid':
    'Los tamaños vinculados están disponibles en Pro y Business: edita una plantilla y se actualizan todos los tamaños.',
  'linked.badgeSize': 'tamaño vinculado',
  'linked.badgeMaster': 'conjunto · {n}',
  'billing.fLinked': 'Tamaños vinculados',
  'quality.title': 'Control de calidad',
  'quality.found': '{n} de {total} banners tienen problemas',
  'quality.clean': 'Control de calidad: no se encontraron problemas ({total})',
  'quality.checking': 'Comprobando la calidad a medida que se generan las imágenes…',
  'quality.hint':
    'Texto cortado o muy reducido, imágenes ausentes o borrosas, capas fuera del lienzo.',
  'quality.showIssues': 'Mostrar solo con problemas',
  'quality.showAll': 'Mostrar todo',
  'quality.markerTitle': 'Problemas: {n}',
  'issue.text_overflow': 'el texto no cabe y se corta',
  'issue.text_shrunk': 'el texto se redujo de {from} a {to} px para caber',
  'issue.image_missing': 'no se pudo cargar la imagen',
  'issue.image_lowres': 'imagen de {width}×{height} ampliada {upscale}×: se verá borrosa',
  'issue.offcanvas': 'la capa está fuera del lienzo',
  'linked.original': 'original',
  'linked.setHeader': 'Conjunto “{name}”',
  'linked.setCount': '{n} tamaños',
  'linked.setHint': 'las ediciones del original se aplican a todos los tamaños',
  'linked.filterAll': 'Todas',
  'linked.filterSets': 'Conjuntos',
  'linked.filterSingles': 'Individuales',
  'linked.backToAll': 'Todas las plantillas',
  'linked.allSizes': 'Todos los tamaños',
  'linked.allSizesHint':
    'Muestra todos los tamaños del conjunto uno junto a otro en un solo lienzo. Los cambios del original se ven en todos los tamaños al instante',
  'linked.openSize': 'Haz clic para editar este tamaño',
  'linked.fitAll': 'Mostrar todos los tamaños',
  'linked.fitCurrent': 'Solo el tamaño abierto',
  'editor.paddingX': 'Izquierda y derecha',
  'editor.paddingY': 'Arriba y abajo',
  'editor.paddingSides': 'Cada lado por separado',
  'editor.paddingAxes': 'Horizontal y vertical',
  'editor.pad_top': 'Arriba',
  'editor.pad_right': 'Derecha',
  'editor.pad_bottom': 'Abajo',
  'editor.pad_left': 'Izquierda',
  'billing.status.active': 'activa',
  'billing.status.trialing': 'prueba',
  'billing.status.past_due': 'pago fallido',
  'billing.status.unpaid': 'impagada',
  'billing.status.canceled': 'cancelada',
  'billing.status.expired': 'finalizada',
  'billing.card': 'Tarjeta {brand} •••• {last4}',
  'billing.graceTitle': 'Pago fallido',
  'billing.graceText':
    'Actualiza el método de pago; de lo contrario, después del {date} el espacio de trabajo pasará de {plan} a Free.',
  'billing.unpaidTitle': 'Suscripción suspendida',
  'billing.unpaidText':
    'No recibimos el pago, así que el espacio de trabajo está en el plan Free. Actualiza la tarjeta: el plan se restablecerá justo después del pago.',
  'billing.updateCard': 'Actualizar método de pago',
  'billing.history': 'Historial de pagos',
  'billing.invoice': 'Factura',
  'billing.reason.initial': 'Suscripción',
  'billing.reason.renewal': 'Renovación',
  'billing.reason.update': 'Cambio de plan',
  'billing.graceBanner': 'Pago fallido: el plan funciona hasta el {date}:',
  'billing.graceBannerLink': 'Actualizar tarjeta',
  'admin.prices': 'Precios',
  'admin.pricesHint':
    'Precios de los planes en cada moneda. Los visitantes ven la moneda de su país; los pagos se cobran en {currency}.',
  'admin.currencyOn': 'Mostrar',
  'admin.perMonth': 'al mes',
  'admin.perYear': 'al año',
  'admin.pricesSaved': 'Precios guardados',
  'admin.pricesReset': 'Precios predeterminados',
  'admin.chargeCurrency': 'moneda de pago',
  'billing.chargedMonth': 'Se cobran {amount} al mes',
  'billing.chargedYear': 'Se cobran {amount} al año',
  'billing.billedYearly': '{amount} facturados al año',
  'err.network': 'No hay conexión con el servidor. Revisa tu conexión e inténtalo de nuevo.',
  'err.seePlans': 'Ver planes',
  'err.internal': 'Algo salió mal por nuestra parte. Inténtalo de nuevo en un minuto.',
  'err.validation': 'Revisa los campos marcados.',
  'err.notFound': 'No se encontró: puede que ya se haya eliminado.',
  'err.forbidden': 'No tienes permiso para hacer esto.',
  'err.tooLarge': 'El archivo es demasiado grande.',
  'err.rateLimited': 'Demasiadas solicitudes. Inténtalo de nuevo en {seconds} s.',
  'err.signIn': 'Tu sesión ha terminado: vuelve a iniciar sesión.',
  'err.notMember': 'No eres miembro de este espacio de trabajo.',
  'err.roleRequired': 'Necesitas el rol «{role}» o superior.',
  'err.templateLimit': 'Tu plan permite hasta {limit} plantillas. Mejora tu plan para crear más.',
  'err.membersLimit':
    'Tu plan permite hasta {limit} miembros. Mejora tu plan para invitar a más personas.',
  'err.automationsLimit':
    'Tu plan permite hasta {limit} automatizaciones. Mejora tu plan para añadir más.',
  'err.customSizesLimit': 'El plan {plan} permite hasta {limit} tamaños propios.',
  'err.customSizesPlan':
    'Los tamaños propios no están disponibles en el plan {plan}. Mejora tu plan para guardarlos.',
  'err.rendersLimit':
    'Has usado el límite mensual de generaciones ({used} de {limit} en el plan {plan}). Mejora tu plan para continuar.',
  'err.aiLimit':
    'Has usado el límite mensual de solicitudes de IA ({used} de {limit} en el plan {plan}).',
  'err.storageLimit':
    'El almacenamiento está lleno (límite: {mb} MB). Elimina archivos que no uses o mejora tu plan.',
  'err.batchLimit':
    'El plan {plan} genera hasta {limit} imágenes por ejecución (solicitadas: {requested}).',
  'err.scaleLimit': 'La escala {scale}× no está disponible en el plan {plan} (máximo {max}×).',
  'err.scaleTooLarge':
    'La plantilla «{name}» se puede ampliar como máximo {max}x: las imágenes tienen como máximo {side} px por lado y {mpx} Mpx.',
  'err.outputTooLarge':
    'La imagen tendría {width}×{height} px; el máximo es {max} px por lado. Usa una escala menor.',
  'err.linkedSizesPlan': 'Los tamaños vinculados están disponibles a partir del plan Pro.',
  'err.customFontsPlan': 'Las fuentes propias están disponibles a partir del plan Pro.',
  'err.integrationsPlan': 'Google Drive y S3 están disponibles en los planes de pago.',
  'err.schedulePlan': 'La ejecución programada está disponible a partir del plan Pro.',
  'err.signedUrlsPlan': 'Los enlaces firmados a imágenes están disponibles en los planes de pago.',
  'err.templateInvalid':
    'La plantilla está dañada y no se puede guardar. Recarga la página e inténtalo de nuevo.',
  'err.sizeRange': 'El ancho y el alto deben ser números enteros de {min} a {max} px.',
  'err.templateConflict':
    'La plantilla se cambió en otra pestaña o la cambió alguien del equipo. Recarga para obtener la última versión.',
  'err.notLinkedSize': 'Esta plantilla no está vinculada a una principal.',
  'err.layerInvalid': 'Capa «{layer}»: {detail}',
  'err.batchEmpty': 'No hay nada que generar: no hay filas.',
  'err.zipNotReady': 'El ZIP aún se está preparando: espera un momento.',
  'err.fileTooLarge': 'El archivo es demasiado grande: máximo {mb} MB.',
  'err.imageType':
    'Admitidos: imágenes PNG, JPG, WEBP, GIF, AVIF y SVG, vídeos MP4, MOV y WEBM y música MP3, M4A, WAV, OGG y FLAC.',
  'err.imageDownload': 'No se pudo descargar la imagen del enlace (HTTP {status}).',
  'err.urlUnreachable': 'No se puede acceder al enlace. Revisa la dirección: debe ser pública.',
  'err.noFile': 'Elige un archivo.',
  'err.fontType': 'Sube una fuente TTF, OTF, WOFF o WOFF2.',
  'err.fontFamilyRequired': 'Escribe el nombre de la fuente.',
  'err.csvParse': 'No se pudo leer el CSV: {detail}',
  'err.jsonInvalid': 'El enlace no devuelve JSON.',
  'err.jsonShape': 'El JSON debe ser una lista de objetos (o {"rows": [...]}).',
  'err.sheetLink': 'Esto no parece un enlace de Hojas de cálculo de Google.',
  'err.sheetPrivate':
    'La hoja es privada. Compártela con «Cualquier persona con el enlace» o conecta una cuenta de Google.',
  'err.sourceAccessDenied': 'Se denegó el acceso a los datos (HTTP {status}).',
  'err.sourceHttp': 'La fuente de datos devolvió un error (HTTP {status}).',
  'err.sourceEmpty': 'La fuente de datos no tiene filas.',
  'err.noHeaderRow': 'El archivo no tiene fila de encabezados.',
  'err.apiSource':
    'Esta automatización recibe las filas por la API: ejecútala con POST /v1/automations/{id}/runs.',
  'err.apiRowsRequired': 'Envía las filas («rows») para ejecutarla.',
  'err.templatesMissing': 'Algunas plantillas elegidas ya no existen: vuelve a elegirlas.',
  'err.templatesGone': 'Las plantillas elegidas ya no existen: elige otras.',
  'err.scheduleApi': 'Las automatizaciones con datos de la API no se pueden programar.',
  'err.cronInvalid': 'La programación no es válida.',
  'err.endpointInvalid': 'Endpoint: {detail}',
  'err.bucketWrite': 'No se pudo escribir en el bucket: {detail}',
  'err.signupsDisabled': 'El registro está cerrado en este servidor.',
  'err.emailTaken': 'Ya existe una cuenta con este email: inicia sesión.',
  'err.badCredentials': 'Email o contraseña incorrectos.',
  'err.accountBlocked': 'Esta cuenta está bloqueada. Contacta con soporte.',
  'err.resetInvalid':
    'El enlace para restablecer la contraseña no es válido o ha caducado: pide uno nuevo.',
  'err.wrongPassword': 'La contraseña actual es incorrecta.',
  'err.googleDisabled': 'Google no está configurado en este servidor.',
  'err.googleError': 'Google devolvió un error: {detail}',
  'err.googleNoRefresh':
    'Google no concedió acceso permanente. Quita el acceso de la app en tu cuenta de Google y vuelve a conectarla.',
  'err.googleNoEmail': 'Tu cuenta de Google no tiene un email verificado.',
  'err.googleOtherAccount': 'Este email está vinculado a otra cuenta de Google.',
  'err.ownerOnlyTransfer': 'Solo el propietario puede transferir la propiedad.',
  'err.lastOwner': 'El espacio de trabajo necesita al menos un propietario.',
  'err.ownerOnlyRemoveOwner': 'Solo un propietario puede eliminar a otro propietario.',
  'err.inviteOwner': 'Invítala como administrador y transfiere la propiedad más tarde.',
  'err.alreadyMember': 'Esta persona ya es miembro.',
  'err.invitationInvalid': 'Esta invitación no es válida o ha caducado.',
  'err.invitationOtherEmail':
    'La invitación se envió a {email}. Inicia sesión con ese email para aceptarla.',
  'err.adminOnlyRemove': 'Solo los administradores pueden eliminar miembros.',
  'err.onlyWorkspace': 'No puedes eliminar tu único espacio de trabajo.',
  'err.cancelBeforeDelete': 'Cancela la suscripción antes de eliminar el espacio de trabajo.',
  'err.blockSelf': 'No puedes bloquearte a ti mismo.',
  'err.deleteSelf': 'No puedes eliminarte a ti mismo.',
  'err.deleteSuperadmin': 'No puedes eliminar a un superadministrador.',
  'err.paymentsDisabled': 'Los pagos no están configurados en este servidor.',
  'err.paymentProvider': 'El servicio de pago devolvió un error: inténtalo de nuevo.',
  'err.planNotForSale': 'Este plan aún no se puede contratar.',
  'err.noSubscription': 'Este espacio de trabajo aún no tiene suscripción.',
  'err.portalUnavailable':
    'El portal de facturación no está disponible ahora: inténtalo más tarde.',
  'err.cancelInPortal': 'Cancela la suscripción en el portal de facturación.',
  'err.planSwitchDisabled': 'El cambio de plan sin pago está desactivado.',
  'err.pricesChargeCurrency':
    'Se necesitan precios en {currency}: los pagos se cobran en esa moneda.',
  'err.aiDisabled': 'Las funciones de IA están desactivadas en este servidor.',
  'err.aiBusy': 'La IA está ocupada ahora: inténtalo en un minuto.',
  'err.code.bad_request': 'No funcionó: revisa los datos e inténtalo de nuevo.',
  'err.code.validation_error': 'Revisa los campos marcados.',
  'err.code.unauthorized': 'Inicia sesión.',
  'err.code.forbidden': 'No tienes permiso para hacer esto.',
  'err.code.not_found': 'No se encontró: puede que ya se haya eliminado.',
  'err.code.conflict': 'Hay un conflicto con los datos actuales: recarga la página.',
  'err.code.plan_limit': 'No disponible en tu plan.',
  'err.code.quota_exceeded': 'Has alcanzado el límite de tu plan.',
  'err.code.payment_required': 'Se necesita un plan de pago.',
  'err.code.rate_limited': 'Demasiadas solicitudes: inténtalo en un minuto.',
  'err.code.payload_too_large': 'El archivo es demasiado grande.',
  'err.code.unsupported_media_type': 'Este tipo de archivo no es compatible.',
  'err.code.internal_error': 'Algo salió mal por nuestra parte. Inténtalo de nuevo en un minuto.',
  'err.code.service_unavailable':
    'El servicio no está disponible temporalmente: inténtalo más tarde.',
  'err.field.required': 'Rellena el campo «{field}»',
  'err.field.choose': 'Elige al menos uno: «{field}»',
  'err.field.minLength': '«{field}»: longitud mínima: {n}',
  'err.field.maxLength': '«{field}»: longitud máxima: {n}',
  'err.field.min': '«{field}»: como mínimo {n}',
  'err.field.max': '«{field}»: como máximo {n}',
  'err.field.email': 'Escribe un email válido',
  'err.field.url': '«{field}»: escribe un enlace completo que empiece por https://',
  'err.field.invalid': 'Revisa el campo «{field}»',
  'field.name': 'Nombre',
  'field.templateIds': 'Plantillas',
  'field.dataSource.url': 'Enlace a los datos',
  'field.dataSource.rows': 'Tabla',
  'field.dataSource.columns': 'Columnas de la tabla',
  'field.dataSource.sheet': 'Hoja',
  'field.dataSource.integrationId': 'Cuenta de Google',
  'field.mapping.rules.layer': 'Capa de una regla',
  'field.mapping.rules.column': 'Columna de una regla',
  'field.mapping.rules.value': 'Valor de una regla',
  'field.output.formats': 'Formatos de archivo',
  'field.output.scale': 'Escala',
  'field.output.quality': 'Calidad',
  'field.output.filenamePattern': 'Nombres de archivo',
  'field.destinations.url': 'URL del webhook',
  'field.destinations.folderName': 'Carpeta de Google Drive',
  'field.destinations.integrationId': 'Cuenta para exportar',
  'field.destinations.prefix': 'Carpeta del bucket',
  'field.schedule.cron': 'Programación',
  'field.schedule.timezone': 'Zona horaria',
  'field.email': 'Email',
  'field.password': 'Contraseña',
  'field.newPassword': 'Nueva contraseña',
  'field.currentPassword': 'Contraseña actual',
  'field.workspaceName': 'Nombre del espacio de trabajo',
  'field.width': 'Ancho',
  'field.height': 'Alto',
  'field.brief': 'Descripción',
  'field.text': 'Texto',
  'field.url': 'Enlace',
  'field.bucket': 'Bucket',
  'field.region': 'Región',
  'field.endpoint': 'Endpoint',
  'field.publicBaseUrl': 'URL pública de archivos',
  'field.accessKeyId': 'Access Key ID',
  'field.secretAccessKey': 'Secret Access Key',
  'field.defaultWebhookUrl': 'Webhook predeterminado',
  'field.family': 'Nombre de la fuente',
  'field.tags': 'Etiquetas',
  'field.format': 'Formato',
  'field.scale': 'Escala',
  'field.quality': 'Calidad',
  'field.modifications': 'Datos de las capas',
  'common.more': 'Más',
  'common.name': 'Nombre',
  'common.notFound': 'No encontrado',
  'common.nothingFound': 'No se encontró nada',
  'common.open': 'Abrir',
  'common.openNewTab': 'Abrir en una pestaña nueva',
  'common.save': 'Guardar',
  'common.saved': 'Guardado',
  'common.search': 'Buscar',
  'common.uploading': 'Subiendo…',
  'role.owner': 'Propietario',
  'role.admin': 'Administrador',
  'role.editor': 'Editor',
  'role.viewer': 'Lector',
  'nav.templates': 'Plantillas',
  'nav.automations': 'Automatizaciones',
  'nav.renders': 'Imágenes generadas',
  'nav.assets': 'Biblioteca de medios',
  'nav.fonts': 'Fuentes',
  'nav.api': 'API y claves',
  'nav.integrations': 'Integraciones',
  'nav.settings': 'Configuración',
  'nav.billing': 'Plan y facturación',
  'nav.developers': 'Desarrolladores',
  'nav.workspace': 'Espacio de trabajo',
  'nav.workspaces': 'Espacios de trabajo',
  'nav.newWorkspace': 'Nuevo espacio de trabajo',
  'nav.profile': 'Perfil',
  'nav.logout': 'Cerrar sesión',
  'nav.rendersThisMonth': 'Generaciones en este periodo',
  'nav.upgrade': 'Mejorar plan',
  'auth.google': 'Continuar con Google',
  'auth.or': 'o',
  'auth.error.google_denied': 'Se canceló el inicio de sesión con Google',
  'auth.error.google_state': 'La sesión de inicio expiró; inténtalo de nuevo',
  'auth.error.google_failed': 'No se pudo iniciar sesión con Google',
  'auth.error.google_unavailable':
    'El inicio de sesión con Google no está configurado en este servidor',
  'settings.setPassword': 'Establecer contraseña',
  'settings.googleNoPassword':
    'Inicias sesión con Google. Establece una contraseña para poder entrar también con tu correo.',
  'auth.loginTitle': 'Inicia sesión en Bannermatic',
  'auth.loginSubtitle': 'Te damos la bienvenida de nuevo',
  'auth.signupTitle': 'Crea tu cuenta',
  'auth.signupSubtitle': 'Plan Free, sin tarjeta de crédito',
  'auth.email': 'Correo electrónico',
  'auth.password': 'Contraseña',
  'auth.passwordHint': 'Al menos 8 caracteres',
  'auth.name': 'Nombre',
  'auth.company': 'Empresa o equipo',
  'auth.companyHint': 'Nombre del espacio de trabajo: puedes cambiarlo más tarde',
  'auth.forgot': '¿Olvidaste la contraseña?',
  'auth.loginButton': 'Iniciar sesión',
  'auth.signupButton': 'Crear cuenta',
  'auth.noAccount': '¿No tienes cuenta?',
  'auth.haveAccount': '¿Ya tienes cuenta?',
  'auth.signupLink': 'Regístrate',
  'auth.loginLink': 'Inicia sesión',
  'auth.freePlanNote': '50 generaciones gratis cada mes',
  'auth.forgotTitle': 'Restablece tu contraseña',
  'auth.forgotSubtitle': 'Te enviaremos un enlace de restablecimiento por correo',
  'auth.forgotSent': 'Si la cuenta existe, el correo está en camino. Revisa tu bandeja de entrada.',
  'auth.sendLink': 'Enviar enlace',
  'auth.resetTitle': 'Establece una nueva contraseña',
  'auth.newPassword': 'Nueva contraseña',
  'auth.resetButton': 'Guardar contraseña',
  'auth.resetDone': 'Contraseña cambiada: inicia sesión',
  'invite.title': 'Invitación al equipo',
  'invite.text': 'Te invitaron a "{workspace}" como {role}.',
  'invite.accept': 'Aceptar invitación',
  'invite.signup': 'Crear una cuenta para {email}',
  'templates.description':
    'Plantillas de banners con capas dinámicas para la API y las automatizaciones',
  'templates.new': 'Nueva plantilla',
  'templates.newTitle': 'Nueva plantilla',
  'templates.untitled': 'Sin título',
  'templates.createAndEdit': 'Crear y abrir el editor',
  'templates.customSize': 'Tamaño personalizado',
  'templates.groupSocial': 'Redes sociales',
  'templates.groupAds': 'Anuncios display',
  'templates.groupWeb': 'Web y correo',
  'templates.groupVideo': 'Vídeo',
  'templates.groupPrint': 'Impresión',
  'templates.count': '{n} en total',
  'templates.emptyTitle': 'Crea tu primera plantilla',
  'templates.emptyText':
    'Diseña un banner, pon nombres claros a las capas y genera cientos de variantes mediante la API o una hoja de cálculo.',
  'templates.duplicateAs': 'Copiar en otro tamaño',
  'templates.duplicateAsHint':
    'Las capas se adaptan según su comportamiento de redimensionado; después revisa el diseño.',
  'templates.duplicated': 'Copia creada',
  'sizes.mine': 'Tus tamaños',
  'sizes.standard': 'Estándar',
  'sizes.save': 'Guardar tamaño',
  'sizes.saved': 'Tamaño guardado en el espacio de trabajo',
  'sizes.paid': 'Tamaños propios para cualquier plataforma, desde Starter',
  'sizes.limit': 'Tu plan permite hasta {n} tamaños propios',
  'sizes.namePlaceholder': 'Nombre, p. ej., “Pantalla del vestíbulo”',
  'billing.fSizes': 'Hasta {n} tamaños propios',
  'billing.fSizesUnlimited': 'Tamaños propios ilimitados',
  'templates.copyName': '{name} (copia)',
  'duplicate.menu': 'Duplicar…',
  'duplicate.title': 'Duplicar plantilla',
  'duplicate.sameSize': 'Mismo tamaño {size}',
  'duplicate.otherSize': 'Otro tamaño + diseño automático',
  'templates.exportJson': 'Exportar JSON',
  'templates.importTitle': 'Importar plantilla',
  'templates.importHint':
    'SVG de Figma (Copy as SVG o Export → SVG), archivos .json de Bannermatic o exportaciones de Placid, varios a la vez',
  'templates.dropJson': 'Arrastra archivos o haz clic para elegir',
  'templates.figmaTitle': 'Cómo exportar desde Figma',
  'templates.figmaStep1': 'Selecciona el frame del banner (Frame, no un grupo).',
  'templates.figmaStep2': 'En Export, abajo a la derecha, pulsa «+» y elige SVG.',
  'templates.figmaStep3':
    'Pulsa «…» junto a SVG y desmarca «Outline text» para que los textos sigan siendo texto.',
  'templates.figmaStep4': 'Pulsa Export y arrastra aquí el archivo .svg.',
  'templates.figmaNote':
    'Más rápido: clic derecho en el frame → Copy/Paste as → Copy as SVG y Ctrl+V (⌘V) aquí, pero los textos llegarán como contornos. Las fuentes que faltan se sustituyen por otras parecidas y se resaltan: súbelas para que quede idéntico.',
  'templates.svg.fontsReplaced':
    'Faltan fuentes del diseño, se sustituyeron por ahora: {fonts}. Esos textos se resaltan en el editor: sube las fuentes y aplícalas con un clic.',
  'templates.svg.uploadFonts': 'Subir fuentes',
  'templates.svg.outlined':
    'Los textos de este SVG son contornos y no se pueden editar. En Figma: Export → SVG → «…» → desmarca «Outline text» e importa de nuevo. O selecciona esa imagen en el editor → «¿Es texto?».',
  'editor.missingFontTitle': 'La fuente «{font}» no está subida',
  'editor.missingFontText':
    'El texto se muestra con {used} y así saldrá en el render. Sube la fuente en la página «Fuentes» y aquí aparecerá el botón «Aplicar».',
  'editor.missingFontFound': 'La fuente {font} ya está en el espacio.',
  'editor.missingFontApply': 'Aplicar {font}',
  'editor.missingFontUpload': 'Subir la fuente',
  'editor.missingFontKeep': 'Mantener {used}',
  'editor.fontNotInWorkspace':
    'Esta fuente no está en el espacio. El editor puede mostrarla desde las fuentes de tu ordenador, pero los renders usarán otra fuente. Sube el archivo de la fuente o elige otra.',
  'editor.textFromImageTitle': '¿Es texto?',
  'editor.textFromImageHint':
    'Figma suele exportar los textos como contornos. Convierte esta imagen en texto editable en el mismo lugar.',
  'editor.textFromImageManual': 'Sustituir por una capa de texto',
  'editor.textFromImagePlaceholder': 'Texto',
  'templates.importButton': 'Importar: Figma, JSON',
  'templates.importing': 'Importando… las imágenes se suben a la mediateca',
  'templates.importFormats': 'SVG de Figma · .json de Bannermatic · exportación de Placid',

  'templates.svg.invalid': 'No se pudo leer el SVG. Exporta el frame de Figma como SVG',
  'templates.svg.empty': 'No se encontraron capas en el SVG',
  'templates.svg.tooMany': 'El SVG tiene más de 500 capas: simplifica el diseño',
  'templates.imported': 'Plantilla importada',
  'templates.deleteTitle': '¿Eliminar la plantilla?',
  'templates.deleteText': '"{name}" dejará de estar disponible para la API y las automatizaciones.',
  'gallery.open': 'Biblioteca de plantillas',
  'gallery.title': 'Biblioteca de plantillas',
  'gallery.description':
    'Diseños listos creados con pilas: pon tus textos e imágenes o cambia el tamaño, y el diseño se adapta.',
  'gallery.all': 'Todas',
  'gallery.use': 'Usar',
  'gallery.created': 'Plantilla creada',
  'gallery.fromLibrary': 'O empieza con una plantilla lista',
  'gallery.cat.sale': 'Ofertas',
  'gallery.cat.ecommerce': 'Productos',
  'gallery.cat.event': 'Eventos',
  'gallery.cat.social': 'Redes sociales',
  'gallery.cat.food': 'Comida y cafeterías',
  'gallery.cat.realestate': 'Inmobiliaria',
  'gallery.cat.education': 'Educación',
  'gallery.cat.hiring': 'Empleo',
  'gallery.cat.travel': 'Viajes',
  'gallery.cat.fitness': 'Fitness',
  'gallery.cat.holiday': 'Festividades',
  'gallery.cat.ads': 'Banners web',
  'gallery.cat.beauty': 'Belleza',
  'gallery.cat.auto': 'Motor',
  'gallery.cat.tech': 'Tecnología',
  'gallery.cat.pets': 'Mascotas',
  'ai.create': 'Crear con IA',
  'ai.regenerate': 'Más variantes',
  'ai.credits': 'Solicitudes de IA: {used} de {limit} este mes',
  'ai.disabled': 'La generación con IA no está configurada en el servidor (GEMINI_API_KEY).',
  'aiVideo.title': 'Vídeo a partir de una descripción',
  'aiVideo.placeholder': 'Ej.: lanzamiento de Nova, app de edición, 48% más rápida, estilo oscuro',
  'aiVideo.generate': 'Crear vídeos',
  'aiVideo.generating': 'La IA está dirigiendo variantes…',
  'aiVideo.style_launch': 'Lanzamiento',
  'aiVideo.style_showreel': 'Showreel',
  'aiVideo.style_manifesto': 'Manifiesto',
  'aiVideo.style_data': 'Historia en cifras',
  'aiVideo.style_brand': 'Película de marca',
  'director.title': 'Director IA',
  'director.description':
    'Describe lo que necesitas y para qué. Un agente compone el vídeo o el banner con las herramientas del editor: escenas, textos y fuentes, fotos, motion graphics, efectos de texto, transiciones, cámara y música. Después se edita como cualquier plantilla.',
  'director.video': 'Vídeo',
  'director.banner': 'Banner',
  'director.placeholderVideo':
    'Ej.: vídeo de lanzamiento de Nova, app de edición para creadores. Clave: edición un 48% más rápida. Enérgico, oscuro con naranja, al final «Descarga gratis».',
  'director.placeholderBanner':
    'Ej.: banner de rebajas de verano de zapatillas RUNNER, 30% hasta el domingo, vivo y deportivo, botón «Comprar».',
  'director.run': 'Crear',
  'director.again': 'Otra versión',
  'director.open': 'Abrir en el editor',
  'director.mockNote': 'Modo de prueba sin clave de API: el agente reproduce un guion preparado.',
  'director.logHint': 'Aquí verás cómo el agente compone la pieza, paso a paso.',
  'director.thinking': 'El agente piensa la idea y el guion gráfico…',
  'director.working': 'El agente trabaja · paso {n}',
  'director.fixed': 'Errores corregidos por el camino: {n}',
  'director.previewHint': 'Aquí aparece el resultado',
  'director.tool_plan_style': 'Estilo',
  'director.tool_add_scene': 'Escena',
  'director.tool_add_text': 'Texto',
  'director.tool_add_shape': 'Forma',
  'director.tool_add_photo': 'Foto',
  'director.tool_add_graphic': 'Gráfico',
  'director.tool_add_camera': 'Cámara',
  'director.tool_set_music': 'Música',
  'director.tool_finish': 'Listo',
  'director.tool_add_logo': 'Logotipo',
  'director.tool_update': 'Ajuste',
  'director.tool_remove': 'Eliminado',
  'director.tool_update_scene': 'Ajuste de escena',
  'director.tool_review': 'Revisión',
  'director.reviewFound': '{n} observaciones: las corrijo',
  'director.reviewClean': 'sin observaciones',
  'director.brandDefault': 'Marca: {name}',
  'director.brandNone': 'Sin marca',
  'director.brandHint':
    'Colores, fuentes y logotipo del kit de marca: el resultado queda vinculado a la marca',
  'dictation.start': 'Dictar',
  'dictation.stop': 'Detener dictado',
  'dictation.listening': 'Escuchando…',
  'dictation.lang': 'Idioma del dictado',
  'dictation.denied': 'Sin acceso al micrófono: permítelo en el navegador',
  'dictation.failed': 'No se pudo reconocer la voz',
  'ai.copyVariants': 'Variantes de texto con IA',
  'ai.copyHint': 'Haz clic para usar una variante. Deshaz con Ctrl+Z.',
  'billing.fAi': 'Solicitudes de IA al mes: {n}',
  'billing.aiPeriod': 'Solicitudes de IA en el periodo actual',
  'editor.dropImages': 'Suelta para subir los archivos',
  'editor.saved': 'Guardado',
  'editor.unsaved': 'Cambios sin guardar',
  'editor.saving': 'Guardando…',
  'editor.saveError': 'Error al guardar',
  'editor.conflict': 'Conflicto de versiones',
  'editor.conflictTitle': 'La plantilla se modificó en otro lugar',
  'editor.conflictText':
    'Alguien guardó esta plantilla mientras la editabas. ¿Sobrescribir con tu versión? "Cancelar" recarga la versión más reciente.',
  'editor.overwrite': 'Sobrescribir',
  'editor.undo': 'Deshacer',
  'editor.redo': 'Rehacer',
  'editor.zoomIn': 'Acercar',
  'editor.zoomOut': 'Alejar',
  'editor.zoomFit': 'Ajustar a la pantalla',
  'editor.zoom100': 'Zoom al 100%',
  'editor.selectAll': 'Seleccionar todas las capas',
  'editor.rename': 'Cambiar nombre',
  'editor.resize': 'Redimensionar',
  'editor.testRender': 'Generar',
  'editor.readOnly': 'Solo tienes acceso de lectura.',
  'editor.tabElements': 'Elementos',
  'editor.tabMedia': 'Medios',
  'editor.tabLayers': 'Capas',
  'editor.text': 'Texto',
  'editor.addHeading': 'Título',
  'editor.addSubheading': 'Subtítulo',
  'editor.addBody': 'Texto del cuerpo',
  'editor.presetHeading': 'Título',
  'editor.presetSubheading': 'Subtítulo',
  'editor.presetBody': 'Texto del cuerpo. Haz doble clic para editarlo.',
  'editor.addBadge': 'Insignia −30%',
  'editor.shapes': 'Formas',
  'editor.shapeRectangle': 'Rectángulo',
  'editor.shapeRounded': 'Redondeado',
  'editor.shapeEllipse': 'Elipse',
  'editor.shapeTriangle': 'Triángulo',
  'editor.shapeLine': 'Línea',
  'editor.shapeDiamond': 'Rombo',
  'editor.shapePolygon': 'Polígono',
  'editor.shapeStar': 'Estrella',
  'editor.shapeBurst': 'Explosión',
  'editor.shapeHeart': 'Corazón',
  'editor.shapeArrow': 'Flecha',
  'editor.shapeChevron': 'Chevrón',
  'editor.shapeCross': 'Más',
  'editor.shapeBubble': 'Bocadillo',
  'editor.shapeRibbon': 'Cinta',
  'editor.shapeTag': 'Etiqueta',
  'editor.shapeParallelogram': 'Paralelogramo',
  'editor.shapeSemicircle': 'Semicírculo',
  'editor.shapeBlob': 'Mancha',
  'editor.shapeIcon': 'Icono',
  'editor.shapePoints': 'Puntas',
  'editor.shapeSides': 'Lados',
  'editor.shapeInner': 'Profundidad',
  'editor.secTextStyles': 'Estilos de texto',
  'editor.secStickers': 'Pegatinas e insignias',
  'editor.secIcons': 'Iconos',
  'editor.secInfo': 'Contacto e info',
  'editor.secDecor': 'Marcos y decoración',
  'editor.secOverlays': 'Fondos y capas',
  'editor.iconSearch': 'Buscar: phone, gift, star…',
  'editor.noIcons': 'No se encontró nada',
  'editor.showAllIcons': 'Mostrar todos ({n})',
  'editor.showLess': 'Mostrar menos',
  'editor.elCta': 'Botón',
  'editor.txtCta': 'Compra ahora',
  'editor.elKicker': 'Antetítulo',
  'editor.txtKicker': 'Novedad de temporada',
  'editor.elHighlight': 'Resaltado',
  'editor.txtHighlight': 'Solo hoy',
  'editor.elOutline': 'Contorno',
  'editor.elNeon': 'Neón',
  'editor.txtNeon': 'Abierto',
  'editor.elScript': 'Manuscrito',
  'editor.txtScript': 'Con amor',
  'editor.elElegant': 'Elegante',
  'editor.elPoster': 'Cartel',
  'editor.elQuote': 'Cita',
  'editor.txtQuote': '«¡El mejor café de la ciudad!»',
  'editor.elPrice': 'Precio rebajado',
  'editor.elFineprint': 'Letra pequeña',
  'editor.txtFineprint': '*Oferta válida hasta el 31 de diciembre',
  'editor.elSale': 'Rebajas',
  'editor.txtSale': 'SALE',
  'editor.elDiscount': 'Descuento',
  'editor.elNew': 'Nuevo',
  'editor.txtNew': 'NUEVO',
  'editor.elRibbon': 'Cinta',
  'editor.txtRibbon': 'MÁS VENDIDO',
  'editor.elTag': 'Etiqueta',
  'editor.elBubble': 'Bocadillo',
  'editor.txtBubble': '¡Guau!',
  'editor.elLove': 'Corazón',
  'editor.elShipping': 'Envío',
  'editor.txtShipping': 'Envío gratis',
  'editor.elRating': 'Valoración',
  'editor.elTimer': 'Cuenta atrás',
  'editor.elPhone': 'Teléfono',
  'editor.elAddress': 'Dirección',
  'editor.txtAddress': 'Calle Mayor, 1',
  'editor.elWebsite': 'Web',
  'editor.elDate': 'Fecha',
  'editor.txtDate': '12 de mayo · 19:00',
  'editor.elSocial': 'Redes',
  'editor.elChecklist': 'Lista',
  'editor.txtChecklist': 'Ventaja {n}',
  'editor.elFrame': 'Marco',
  'editor.elDashedFrame': 'Marco discontinuo',
  'editor.elRing': 'Anillo',
  'editor.elDivider': 'Acento',
  'editor.elDottedLine': 'Puntos',
  'editor.elCircles': 'Círculos',
  'editor.elBlob': 'Mancha',
  'editor.elShadeBottom': 'Sombra abajo',
  'editor.elShadeTop': 'Sombra arriba',
  'editor.elShadeLeft': 'Sombra izquierda',
  'editor.elVignette': 'Viñeta',
  'editor.elTint': 'Tinte',
  'editor.elDuotone': 'Duotono',
  'editor.elHalfPanel': 'Mitad',
  'editor.elDiagonal': 'Diagonal',
  'editor.elArc': 'Arco inferior',
  'editor.stockPhotos': 'Fotos',
  'editor.stockHint':
    'Fotos libres de derechos: úsalas en banners comerciales sin atribución. Haz clic para insertar o reemplazar la imagen seleccionada.',
  'editor.photoTag.all': 'Todas',
  'editor.photoTag.people': 'Personas',
  'editor.photoTag.beauty': 'Belleza',
  'editor.photoTag.food': 'Comida',
  'editor.photoTag.travel': 'Viajes',
  'editor.photoTag.home': 'Hogar',
  'editor.photoTag.business': 'Negocios',
  'editor.photoTag.sport': 'Deporte',
  'editor.photoTag.holiday': 'Fiestas',
  'editor.photoTag.auto': 'Coches',
  'editor.photoTag.pets': 'Mascotas',
  'editor.photoTag.nature': 'Naturaleza',
  'editor.dynamic': 'Dinámicos',
  'editor.imagePlaceholder': 'Foto / logotipo',
  'editor.qr': 'Código QR',
  'editor.dynamicHint':
    'Cualquier capa se puede cambiar mediante la API por su nombre: texto, imagen, color, posición.',
  'editor.noLayers': 'Aún no hay capas. Añade texto, una forma o una imagen.',
  'editor.uploadImages': 'Subir imágenes o vídeos',
  'editor.uploadNew': 'Subir nueva',
  'editor.mediaHint':
    'Haz clic para insertar o para reemplazar la imagen seleccionada. También puedes soltar archivos en el lienzo.',
  'editor.noUploads': 'Aún no hay archivos subidos',
  'editor.removeImage': 'Quitar imagen',
  'editor.placeholderImage': 'Marcador de posición: la imagen llega desde la API',
  'editor.replaceImage': 'Reemplazar imagen o vídeo',
  'editor.dropToReplace': 'Suelta para reemplazar',
  'editor.chooseImage': 'Elegir imagen o vídeo',
  'editor.imageUrl': 'o pega la URL de una imagen',
  'editor.template': 'Plantilla',
  'editor.canvasSize': 'Tamaño del lienzo',
  'editor.customSize': 'Tamaño personalizado',
  'editor.resizeHint':
    'Con la adaptación activada, las capas siguen su comportamiento de redimensionado. Deshaz con Ctrl+Z.',
  'editor.background': 'Fondo',
  'editor.transparentHint': 'El fondo transparente se conserva en PNG y WEBP.',
  'editor.tips': 'Consejos',
  'editor.tipNames':
    'Pon nombres claros a las capas (title, photo, price): los datos se asignan a ellas en la API y en las hojas de cálculo.',
  'editor.tipShortcuts':
    'Ctrl+Z / Ctrl+Shift+Z, Ctrl+D duplicar, flechas para desplazar (Shift ×10), Ctrl+rueda para zoom, Espacio para mover la vista, mantén Alt para medir distancias.',
  'editor.tipTools':
    'Herramientas: R rectángulo, U redondeado, O elipse, L línea, T texto, H título (Shift+H subtítulo), B insignia, I foto, Q QR. Arrastra en el lienzo o haz clic; V o Esc para seleccionar.',
  'editor.toolHint': '{tool}: arrastra en el lienzo o haz clic · Esc para cancelar',
  'editor.tipDrop': 'Suelta imágenes en el lienzo para subirlas.',
  'editor.nameInvalid': 'El nombre no puede contener . = & ? # / \\',
  'editor.nameTaken': 'Este nombre ya está en uso',
  'editor.layerNameHint':
    'El nombre de la capa es la clave de la API y la columna de la hoja de cálculo',
  'editor.layerDescription': 'Descripción para la API (opcional)',
  'editor.position': 'Posición y tamaño',
  'editor.constraints': 'Comportamiento al redimensionar',
  'editor.constraintsHint': 'Cómo se adapta la capa cuando cambia el tamaño de la plantilla.',
  'editor.cH': 'Horizontal',
  'editor.cV': 'Vertical',
  'editor.c.auto': 'Auto',
  'editor.c.left': 'Izquierda',
  'editor.c.right': 'Derecha',
  'editor.c.top': 'Arriba',
  'editor.c.bottom': 'Abajo',
  'editor.c.center': 'Centro',
  'editor.c.stretch': 'Estirar',
  'editor.c.scale': 'Escalar',
  'editor.c.proportional': 'proporcional',
  'editor.adaptLayers': 'Adaptar capas',
  'editor.applySize': 'Aplicar tamaño',
  'resize.preview': 'Vista previa',
  'resize.extremeWarning':
    'La relación de aspecto cambia mucho: revisa el diseño después de copiar.',
  'editor.stack': 'Pila',
  'editor.stackExpand': 'Mostrar las capas de la pila',
  'editor.stackCollapse': 'Plegar la pila',
  'editor.groupStack': 'Convertir en pila',
  'editor.ungroupStack': 'Desagrupar',
  'editor.stackLayout': 'Diseño automático',
  'editor.dirVertical': 'Columna',
  'editor.dirHorizontal': 'Fila',
  'editor.dirAuto': 'Auto',
  'editor.dirFree': 'Ninguna',
  'editor.dirFreeHint':
    'Sin disposición automática: las capas quedan donde las pusiste (un texto sobre un botón) y se mueven con la pila. Una columna o una fila las alinea automáticamente.',
  'editor.dirAutoHint':
    'Auto: fila cuando el lienzo es al menos N veces más ancho que alto; columna en caso contrario. Un mismo diseño para tamaños horizontales y verticales.',
  'editor.autoRowRatio': 'Fila desde N : 1',
  'editor.gap': 'Espacio',
  'editor.alignItems': 'Alinear',
  'editor.al.start': 'Inicio',
  'editor.al.center': 'Centro',
  'editor.al.end': 'Final',
  'editor.al.stretch': 'Estirar',
  'editor.distribution': 'Distribuir',
  'editor.js.start': 'Inicio',
  'editor.js.center': 'Centro',
  'editor.js.end': 'Final',
  'editor.js.space-between': 'Entre',
  'editor.clip': 'Recortar contenido',
  'editor.inStack': 'En la pila “{name}”',
  'editor.selectStack': 'Seleccionar pila',
  'editor.grow': 'Rellenar espacio libre',
  'editor.earlier': 'Antes',
  'editor.later': 'Después',
  'editor.stackHint':
    'Las capas dentro de una pila se colocan automáticamente: un texto más largo desplaza a los elementos siguientes.',
  'editor.stackFeatText': 'Un texto más largo desplaza solo las capas siguientes',
  'editor.stackFeatGrow':
    'Una capa puede ocupar el espacio libre: activa «Rellenar espacio libre» en la capa',
  'editor.stackFeatAuto': '«Auto»: fila en tamaños anchos, columna en los altos',
  'editor.groupHint': 'Ctrl+G convierte la selección en pila, Ctrl+Shift+G la desagrupa.',
  'editor.copy': 'Copiar',
  'editor.paste': 'Pegar',
  'editor.alignToPage': 'Alinear a la página',
  'editor.alignSelection': 'Alinear',
  'editor.order': 'Orden',
  'editor.setAsBackground': 'Usar como fondo',
  'editor.editText': 'Editar texto',
  'editor.moreActions': 'Más acciones',
  'editor.opacityShort': 'Opac.',
  'editor.alignLeft': 'Alinear a la izquierda',
  'editor.alignHCenter': 'Centrar horizontalmente',
  'editor.alignRight': 'Alinear a la derecha',
  'editor.alignTop': 'Alinear arriba',
  'editor.alignVCenter': 'Centrar verticalmente',
  'editor.alignBottom': 'Alinear abajo',
  'editor.justify': 'Justificar',
  'editor.distributeH': 'Distribuir horizontalmente',
  'editor.distributeV': 'Distribuir verticalmente',
  'editor.arrange': 'Capa',
  'editor.bringFront': 'Traer al frente',
  'editor.bringForward': 'Traer adelante',
  'editor.sendBackward': 'Enviar atrás',
  'editor.sendBack': 'Enviar al fondo',
  'editor.lock': 'Bloquear',
  'editor.unlock': 'Desbloquear',
  'editor.hide': 'Ocultar',
  'editor.show': 'Mostrar',
  'editor.duplicate': 'Duplicar',
  'editor.layersSelected': '{n} capas seleccionadas',
  'editor.clearSelection': 'Borrar selección',
  'editor.typography': 'Tipografía',
  'editor.italic': 'Cursiva',
  'editor.lineHeight': 'Interlineado',
  'editor.lineHeightShort': '↕',
  'editor.letterSpacing': 'Espaciado entre letras',
  'editor.letterSpacingShort': '↔',
  'editor.transformNone': 'Tal como se escribió',
  'editor.uppercase': 'MAYÚSCULAS',
  'editor.lowercase': 'minúsculas',
  'editor.capitalize': 'Capitalizar',
  'editor.dynamicText': 'Texto largo',
  'editor.autoFit': 'Reducir la fuente para que quepa',
  'editor.minFontSize': 'Tamaño mín.',
  'editor.maxLines': 'Líneas máx.',
  'editor.autoFitHint':
    'Útil para texto de la API: el texto corto se mantiene grande y el largo se reduce. 0 líneas = sin límite.',
  'editor.textBox': 'Cuadro de texto',
  'editor.padding': 'Relleno',
  'editor.radius': 'Radio',
  'editor.effects': 'Efectos',
  'editor.stroke': 'Contorno',
  'editor.shadow': 'Sombra',
  'editor.blurShort': 'Desenf.',
  'editor.image': 'Imagen o vídeo',
  'editor.fitCover': 'Cubrir',
  'editor.fitContain': 'Contener',
  'editor.fitFill': 'Estirar',
  'editor.focusX': 'Foco X',
  'editor.focusY': 'Foco Y',
  'editor.videoClip': 'Vídeo',
  'editor.videoClipHint':
    'Clip de {s} s: se reproduce en animaciones y vídeos; las imágenes muestran su primer fotograma.',
  'editor.videoLoop': 'Repetir en bucle',
  'editor.videoSound': 'Con sonido',
  'editor.videoVolume': 'Volumen',
  'editor.videoTrim': 'Fragmento del clip',
  'editor.videoRemove': 'Dejar solo el fotograma',
  'editor.videoPlay': 'Ver vídeo',
  'editor.videoPause': 'Detener vista previa',
  'editor.videoMute': 'Silenciar',
  'editor.videoUnmute': 'Activar sonido',
  'err.videoUnreadable': 'No se pudo leer el vídeo: sube un MP4, MOV o WEBM.',
  'editor.imageApiHint':
    'Pasa una URL mediante la API: {"photo": "https://…"}. La foto se recorta alrededor del punto de foco.',
  'editor.style': 'Estilo',
  'editor.border': 'Borde',
  'editor.brightness': 'Brillo',
  'editor.blur': 'Desenfoque',
  'editor.grayscale': 'Escala de grises',
  'editor.flipX': 'Voltear horizontalmente',
  'editor.flipY': 'Voltear verticalmente',
  'editor.shape': 'Forma',
  'editor.line': 'Línea',
  'editor.width': 'Grosor',
  'editor.strokeSolid': 'Continua',
  'editor.strokeDashed': 'Discontinua',
  'editor.strokeDotted': 'Punteada',
  'editor.qrColor': 'Color',
  'editor.qrMargin': 'Margen',
  'editor.qrLevel': 'Nivel de corrección de errores',
  'editor.pickColor': 'Elegir color',
  'editor.docColors': 'Colores de la plantilla',
  'fold.autoFit': 'ajuste de fuente',
  'fold.maxLines': 'hasta {n} líneas',
  'fold.words': 'palabras: {n}',
  'fold.numbers': 'números',
  'accent.bar': 'Acento',
  'accent.bold': 'Más grueso',
  'accent.underline': 'Subrayar',
  'accent.marker': 'Marcador',
  'accent.markerOn': 'Añadir marcador',
  'accent.markerOff': 'Quitar el marcador',
  'accent.remove': 'Quitar el acento',
  'accent.more': 'Color propio, marcador, tamaño…',
  'accent.textColor': 'Texto',
  'accent.size': 'Tamaño',
  'accent.wordTitle': 'Acento «{word}»',
  'accent.dragHint': 'Arrástralo para ver toda la composición',
  'accent.title': 'Acentos en el texto',
  'accent.hint':
    'Haz doble clic en el texto, selecciona una palabra y elige un color encima, o añade la palabra aquí. La palabra se resalta en cualquier texto que la tenga, también en los datos de una tabla.',
  'accent.wordPlaceholder': 'Una palabra o una frase',
  'accent.add': 'Añadir',
  'accent.dataTitle': 'Acento desde los datos',
  'accent.numbers': 'Números y porcentajes como acento',
  'accent.dataHint':
    'En una tabla o la API: **palabra** en el texto de la celda, una columna «{layer}.accent» con la palabra (varias separadas por «;») o «{layer}.accent_color» con un color.',
  'editor.colorOpacity': 'Opacidad',
  'editor.fillNone': 'Ninguno',
  'editor.fillSolid': 'Sólido',
  'editor.fillLinear': 'Lineal',
  'editor.fillRadial': 'Radial',
  'editor.angle': 'Ángulo',
  'editor.addStop': 'Añadir parada',
  'editor.searchFonts': 'Buscar fuentes',
  'editor.manageFonts': 'Gestionar y subir fuentes',
  'editor.weight100': 'Thin',
  'editor.weight200': 'ExtraLight',
  'editor.weight300': 'Light',
  'editor.weight400': 'Regular',
  'editor.weight500': 'Medium',
  'editor.weight600': 'SemiBold',
  'editor.weight700': 'Bold',
  'editor.weight800': 'ExtraBold',
  'editor.weight900': 'Black',
  'preview.title': 'Generación',
  'preview.description':
    'Rellena los datos y mira el resultado exactamente como lo devuelve la API.',
  'preview.formatImage': 'Imagen',
  'preview.formatVideo': 'Vídeo',
  'preview.deviceHint':
    'El vídeo se crea en este ordenador. No cierres la pestaña hasta que termine.',
  'preview.noFields': 'La plantilla aún no tiene capas.',
  'preview.render': 'Generar',
  'preview.rendering': 'Generando…',
  'preview.empty': 'El resultado aparecerá aquí',
  'preview.openPdf': 'Abrir PDF',
  'apiDialog.title': 'Generar mediante la API',
  'apiDialog.description': 'Capas de esta plantilla y ejemplos de solicitudes listos para usar',
  'apiDialog.reference': 'Referencia completa de la API',
  'apiDialog.layer': 'Capa',
  'apiDialog.type': 'Tipo',
  'apiDialog.properties': 'Propiedades',
  'apiDialog.hint':
    'Crea una clave de API en "API y claves". En lugar de un objeto puedes pasar una cadena: "title": "Texto" o "photo": "https://…".',
  'resize.title': 'Copiar en otro tamaño',
  'resize.description': 'Creamos una copia y adaptamos las capas al nuevo tamaño',
  'resize.preset': 'Tamaños predefinidos',
  'resize.choosePreset': 'Elige un tamaño…',
  'resize.hint':
    'Las plantillas de distintos tamaños con los mismos nombres de capa se pueden generar en una sola ejecución de la automatización.',
  'resize.limitHint': 'Tu plan permite hasta {n} plantillas.',
  'resize.createCopy': 'Crear copia',
  'resize.created': 'Copia creada',
  'automations.description':
    'Generación masiva: datos × plantillas → archivos en un ZIP, Google Drive, S3 o un webhook',
  'automations.new': 'Nueva automatización',
  'automations.emptyTitle': 'Aún no hay automatizaciones',
  'automations.emptyText':
    'Sube un CSV o conecta una hoja de Google, elige plantillas y obtén cientos de creatividades con un clic o de forma programada.',
  'automations.disabled': 'Desactivada',
  'automations.neverRun': 'Nunca ejecutada',
  'automations.runNow': 'Ejecutar ahora',
  'automations.howTitle': 'Cómo funciona',
  'automations.how1':
    'Elige una o varias plantillas (p. ej., cuadrada, historia y un banner de 728×90).',
  'automations.how2':
    'Conecta los datos: CSV, hoja de Google, una URL JSON/CSV o filas mediante la API.',
  'automations.how3':
    'Asigna columnas a capas: las columnas con el mismo nombre que las capas se asignan automáticamente.',
  'automations.how4':
    'Elige formatos y destinos. Ejecuta manualmente, de forma programada o desde la API.',
  'automations.source.table': 'Tabla / CSV',
  'automations.source.google_sheets': 'Hoja de Google',
  'automations.source.url': 'URL (CSV/JSON/XML)',
  'automations.source.api': 'Filas mediante la API',
  'automation.namePlaceholder': 'Nombre de la automatización, p. ej., "Fichas de producto"',
  'automation.enabled': 'Activada',
  'automation.fold': 'Contraer',
  'automation.unfold': 'Desplegar',
  'automation.pickTemplates': 'Elegir plantillas ({n})',
  'automation.changeTemplates': 'Cambiar selección',
  'automation.searchTemplates': 'Buscar plantilla',
  'automation.pickDone': 'Listo: ahora los datos',
  'automation.sumTemplates': 'Elegidas: {n}',
  'automation.sumNoTemplates': 'Ninguna plantilla elegida',
  'automation.sumRows': '{n} filas',
  'automation.sumAuto': 'por nombre de capa',
  'automation.sumRules': '{n} reglas',
  'automation.sumWebhook': 'Webhook',
  'automation.sumManual': 'Manual o por API',
  'automation.step1': 'Plantillas',
  'automation.step1Hint':
    'Cada fila de datos se genera con cada plantilla seleccionada. Elige un conjunto para añadir todos sus tamaños.',
  'automation.noTemplates': 'Primero crea una plantilla.',
  'automation.step2': 'Datos',
  'automation.step2Hint': 'Una fila = un conjunto de creatividades',
  'automation.uploadCsv': 'Subir CSV',
  'automation.csvLoaded': '{n} filas cargadas',
  'automation.columnsFromLayers': 'Columnas a partir de las capas',
  'automation.addColumn': 'Columna',
  'automation.addRow': 'Fila',
  'automation.rowsCount': '{n} filas',
  'automation.rowsHidden': 'Hay {n} filas más ocultas, pero también se generarán.',
  'automation.tableHint':
    'Una columna con el nombre de una capa (title) define su valor principal; "capa.propiedad" (title.color) define una propiedad. Las celdas vacías mantienen el valor de la plantilla.',
  'automation.sheetUrl': 'Enlace a la hoja de Google',
  'automation.sheetHint':
    'Una hoja compartida mediante enlace funciona sin conectar una cuenta. La primera fila debe contener los encabezados.',
  'automation.googleAccount': 'Cuenta de Google',
  'automation.publicSheet': 'Enlace público (sin cuenta)',
  'automation.sheetName': 'Hoja',
  'automation.firstSheet': 'primera hoja',
  'automation.testSource': 'Probar y previsualizar los datos',
  'automation.sourceOk': '{n} filas y {c} columnas cargadas',
  'automation.urlHint': 'Se descarga en cada ejecución: ideal para feeds de productos',
  'automation.xmlHint':
    'Feeds de Google Merchant y Meta (RSS/Atom), YML para Rozetka y Prom o cualquier XML. Cada producto tiene las columnas title, price, old_price, discount, currency, image, link, brand y category: nombra así tus capas y se rellenan solas.',
  'automation.onlyChanged': 'Solo filas nuevas y cambiadas',
  'automation.onlyChangedHint':
    'Cada ejecución genera solo lo nuevo o cambiado desde la anterior (precio, foto, nombre). Si cambias la plantilla, el mapeo o el formato, se genera todo de nuevo. Ideal para un feed diario: no gasta renders en los mismos banners.',
  'automation.keyColumn': 'Columna clave',
  'automation.keyColumnHint': 'Reconoce una fila entre ejecuciones: normalmente id o SKU',
  'automation.keyWholeRow': '— toda la fila —',
  'automation.unchangedShort': 'sin cambios: {n}',
  'batch.unchanged': 'Filas sin cambios omitidas: {n}',
  'batch.nothingChanged':
    'Nada cambió desde la última ejecución ({n} filas): no se gastaron renders.',
  'err.xmlEntities': 'No se admite XML con declaraciones de entidades (<!ENTITY>)',
  'err.xmlParse': 'No se pudo leer el XML: {detail}',
  'err.feedEmpty': 'No se encontraron productos en el feed XML',
  'automation.format': 'Formato',
  'automation.apiHint':
    'Las filas se envían en el cuerpo de la solicitud: práctico para CRM, n8n, Make y Zapier.',
  'automation.step3': 'Asignación de campos',
  'automation.step3Hint': 'Qué va en cada capa',
  'automation.autoMap': 'Asignar automáticamente por nombre',
  'automation.autoMapHint':
    'Las columnas que coinciden con los nombres de las capas se asignan automáticamente',
  'automation.selectTemplatesFirst': 'Selecciona plantillas para ver sus capas.',
  'automation.templatesLoadFailed': 'No se pudieron cargar los campos de las plantillas.',
  'automation.noFieldsInTemplates': 'Las plantillas seleccionadas no tienen capas para rellenar.',
  'automation.value': 'Valor',
  'automation.sample': 'Ejemplo (fila 1)',
  'automation.inTemplates': 'en {n} de {total}',
  'automation.auto': 'Auto: columna {column}',
  'automation.keepTemplate': 'Mantener el valor de la plantilla',
  'automation.column': 'Columna',
  'automation.static': 'Valor fijo',
  'automation.extraRules': 'Reglas adicionales',
  'automation.extraRulesHint':
    'P. ej., el color de la insignia desde una columna "color" o un color de texto fijo.',
  'automation.addRule': 'Añadir regla',
  'automation.previewFirstRow': 'Previsualizar la primera fila',
  'automation.livePreview': 'Vista previa en vivo',
  'automation.prevRow': 'Fila anterior',
  'automation.nextRow': 'Fila siguiente',
  'automation.rowN': 'fila {n} de {total}',
  'automation.livePreviewHint':
    'Pasa el ratón por una capa de la tabla para resaltarla aquí. Haz clic en un elemento del diseño para ver su fila.',
  'automation.livePreviewMedia': 'Las imágenes de la biblioteca ({layers}) se colocan al generar',
  'automation.livePreviewFailed': 'El valor no sirve, la capa queda como en la plantilla: {layers}',
  'automation.lockedLayer': 'Bloqueada en el editor: la automatización no la cambia',
  'automation.step4': 'Salida',
  'automation.formats': 'Formatos',
  'automation.scale': 'Escala',
  'automation.scaleCapped':
    'Las plantillas grandes salen más pequeñas: {list}. Las imágenes tienen como máximo {side} px por lado y {mpx} Mpx.',
  'automation.scaleNotUsed':
    'El PDF es vectorial y los vídeos mantienen el tamaño de la plantilla: la escala no se aplica.',
  'automation.quality': 'Calidad JPG/WEBP',
  'automation.filename': 'Nombre de archivo',
  'automation.filenameHint':
    'Marcadores: {{template}}, {{index}}, {{date}}, {{format}}, {{row.column}}',
  'automation.folders': 'Carpetas para los archivos',
  'automation.foldersHint':
    'Para el ZIP, Google Drive y S3. Elige en orden cómo ordenar los archivos: la primera es la carpeta exterior. Sin elegir, todos los archivos van juntos.',
  'automation.folderExampleTemplate': 'Plantilla',
  'automation.folderBy.template': 'Por plantilla',
  'automation.folderBy.size': 'Por tamaño',
  'automation.folderBy.format': 'Por formato',
  'automation.folderBy.column': 'Por columna',
  'automation.step5': 'Destinos',
  'automation.step5Hint': 'Elige uno o varios',
  'automation.destZip': 'Archivo ZIP para descargar',
  'automation.connectGoogle': 'Conectar Google',
  'automation.connectS3': 'Conectar S3',
  'automation.folderName': 'Carpeta',
  'automation.subfolderPerRun': 'Subcarpeta por ejecución',
  'automation.step6': 'Programación',
  'automation.step6Hint': 'P. ej., descargar el feed cada mañana y actualizar las creatividades',
  'automation.scheduleOn': 'Ejecutar de forma programada',
  'automation.frequency': 'Frecuencia',
  'automation.timezone': 'Zona horaria',
  'automation.nextRuns': 'Próximas ejecuciones',
  'automation.invalidCron': 'Expresión cron no válida',
  'automation.cron.hourly': 'Cada hora',
  'automation.cron.daily': 'Cada día a las 9:00',
  'automation.cron.weekly': 'Los lunes a las 9:00',
  'automation.cron.monthly': 'Cada mes, el día 1 a las 9:00',
  'automation.cron.custom': 'Personalizada',
  'automation.runs': 'Historial de ejecuciones',
  'automation.estimate': 'Se generarán {n} archivos',
  'automation.estimateUnknown': 'La cantidad se conocerá cuando se carguen los datos',
  'automation.overLimit': 'supera el límite de tu plan ({n} por ejecución)',
  'automation.saveAndRun': 'Guardar y ejecutar',
  'automation.saved': 'Automatización guardada',
  'automation.deleteTitle': '¿Eliminar la automatización?',
  'automation.deleteText': 'El historial de ejecuciones y los archivos generados se conservan.',
  'destination.zip': 'Archivo ZIP',
  'destination.google_drive': 'Google Drive',
  'destination.s3': 'Amazon S3 / compatible',
  'destination.webhook': 'Webhook',
  'batch.title': 'Ejecución',
  'batch.status.pending': 'Preparando',
  'batch.status.processing': 'Generando',
  'batch.status.done': 'Completada',
  'batch.status.partial': 'Parcial',
  'batch.status.failed': 'Fallida',
  'batch.trigger.manual': 'manual',
  'batch.trigger.schedule': 'programada',
  'batch.trigger.api': 'mediante la API',
  'batch.total': 'total',
  'batch.done': 'completadas',
  'batch.failed': 'fallidas',
  'batch.finished': 'Finalizada',
  'batch.downloadZip': 'Descargar ZIP',
  'batch.deliveries': 'Entrega',
  'batch.files': '{n} archivos',
  'batch.showingFirst': 'Se muestran los primeros 200 archivos; todos están en el archivo ZIP.',
  'renders.description': 'Todas las imágenes y PDF generados',
  'renders.tabRenders': 'Archivos',
  'renders.tabBatches': 'Lotes',
  'renders.allStatuses': 'Todos los estados',
  'renders.allSources': 'Todos los orígenes',
  'renders.file': 'Archivo',
  'renders.status': 'Estado',
  'renders.source': 'Origen',
  'renders.size': 'Tamaño',
  'renders.created': 'Creado',
  'renders.duration': 'Duración',
  'renders.modifications': 'Modificaciones',
  'renders.emptyTitle': 'Aún no hay imágenes generadas',
  'renders.emptyText':
    'Ejecuta una automatización o llama a la API: los resultados aparecerán aquí.',
  'renders.noBatches': 'Aún no hay lotes',
  'renders.loadMore': 'Cargar más',
  'renders.sources.api': 'API',
  'renders.sources.editor': 'Editor',
  'renders.sources.automation': 'Automatización',
  'renders.sources.url': 'URL firmada',
  'renders.statuses.queued': 'En cola',
  'renders.statuses.rendering': 'Generando',
  'renders.statuses.done': 'Completado',
  'renders.statuses.failed': 'Fallido',
  'assets.description': 'Fotos, logotipos e iconos para tus plantillas',
  'assets.storage': 'Almacenamiento: {used} de {limit}',
  'assets.drop':
    'Arrastra imágenes o vídeos o haz clic para elegir (PNG, JPG, WEBP, SVG, GIF, MP4, MOV, WEBM)',
  'assets.importUrl': 'Importar desde URL',
  'assets.emptyTitle': 'Tu biblioteca de medios está vacía',
  'assets.emptyText': 'Sube logotipos y fotos para usarlos en las plantillas.',
  'assets.copyUrl': 'Copiar URL',
  'assets.deleteTitle': '¿Eliminar el archivo?',
  'assets.deleteText': 'Las plantillas que lo usan mostrarán un área vacía.',
  'fonts.description':
    'Activa las fuentes que necesitas y sube las de tu marca: disponibles en el editor y en las imágenes generadas',
  'fonts.custom': 'Fuentes personalizadas',
  'fonts.builtin': 'Integradas',
  'fonts.customBadge': 'personalizada',
  'fonts.customLocked': 'Fuentes personalizadas en los planes Pro y Business',
  'fonts.filterAll': 'Todas',
  'fonts.filterEnabled': 'Activadas',
  'fonts.filterCyrillic': 'Cirílico',
  'fonts.sampleText': 'El veloz murciélago hindú comía feliz cardillo y kiwi',
  'fonts.cyrillic': 'Cirílico',
  'fonts.cyrShort': 'Cir',
  'fonts.sample': 'Texto de vista previa',
  'fonts.enabledCount': '{n} de {total} activadas',
  'fonts.disableHint':
    'Las fuentes desactivadas se ocultan en el editor; las plantillas existentes se siguen generando correctamente.',
  'fonts.files': 'Archivos subidos',
  'fonts.uploadTitle': 'Subir fuente',
  'fonts.uploadHint':
    'TTF, OTF, WOFF o WOFF2. Sube cada grosor como un archivo independiente con la misma familia.',
  'fonts.dropFont': 'Suelta un archivo de fuente o haz clic',
  'fonts.family': 'Familia',
  'fonts.familyHint': 'Déjalo vacío para leerlo del archivo',
  'fonts.weight': 'Grosor',
  'fonts.style': 'Estilo',
  'fonts.auto': 'Detectar automáticamente',
  'fonts.upload': 'Subir',
  'fonts.uploaded': 'Fuente {family} {weight} subida',
  'fonts.deleteTitle': '¿Eliminar el archivo de fuente?',
  'fonts.deleteText': 'Las plantillas que usan este grosor recurrirán a otra fuente.',
  'api.description': 'Conecta la generación de imágenes a tu sitio web, CRM o scripts',
  'api.keys': 'Claves de API',
  'api.keysHint':
    'Una clave da acceso a todas las plantillas del espacio de trabajo. Guárdala en tu servidor.',
  'api.createKey': 'Crear clave',
  'api.adminOnly': 'Solo los administradores pueden gestionar las claves.',
  'api.noKeys': 'Aún no hay claves',
  'api.created': 'creada',
  'api.lastUsed': 'usada',
  'api.neverUsed': 'nunca usada',
  'api.revoke': 'Revocar',
  'api.revokeTitle': '¿Revocar la clave?',
  'api.revokeText': 'Las solicitudes con "{name}" dejarán de funcionar de inmediato.',
  'api.keyCreated': 'Clave creada',
  'api.copyNow': 'Copia la clave ahora: no volveremos a mostrarla.',
  'api.keyNameHint': 'P. ej., dónde se usa',
  'api.quickstart': 'Inicio rápido',
  'api.reference': 'Referencia',
  'api.tabSingle': 'Una imagen',
  'api.tabBatch': 'Lote',
  'api.tabAsync': 'Asíncrono',
  'api.layersHelp':
    'cambios por nombre de capa: una cadena define el valor principal, un objeto define propiedades y null oculta la capa.',
  'api.scaleHelp': '2 para retina.',
  'api.webhookHelp': 'te avisamos cuando el archivo esté listo (firmado con HMAC).',
  'api.signedTitle': 'URL de imagen firmadas',
  'api.signedHint':
    'La imagen se genera en la primera solicitud y se almacena en caché. Ideal para correos, Open Graph y páginas de destino, sin código de servidor.',
  'api.generateUrl': 'Generar URL',
  'api.urlAppearsHere': 'La URL y la vista previa aparecerán aquí',
  'api.signingSecret': 'Secreto de firma',
  'api.signingSecretHint':
    'Se usa para firmar las URL y los webhooks. Firma las URL en tu lado: consulta el ejemplo.',
  'api.reveal': 'Mostrar',
  'api.rotate': 'Rotar secreto',
  'api.rotateTitle': '¿Rotar el secreto?',
  'api.rotateText':
    'Todas las URL firmadas emitidas anteriormente dejarán de funcionar y los webhooks usarán el nuevo secreto.',
  'integrations.description': 'De dónde vienen los datos y adónde van los archivos',
  'integrations.locked': 'Las integraciones están disponibles desde Starter.',
  'integrations.googleHint': 'Lee hojas de Google y sube archivos a Google Drive',
  'integrations.googleNotConfigured':
    'Google OAuth no está configurado en el servidor (GOOGLE_CLIENT_ID / GOOGLE_CLIENT_SECRET). Las hojas públicas funcionan sin él.',
  'integrations.connectGoogle': 'Conectar cuenta de Google',
  'integrations.googleConnected': 'Google conectado',
  'integrations.googleReconnected':
    'Esta cuenta de Google ya estaba conectada: se renovó el acceso',
  'integrations.googleFailed': 'No se pudo conectar Google',
  'integrations.s3Short': 'AWS, Cloudflare R2, MinIO, Wasabi, DigitalOcean…',
  'integrations.addBucket': 'Añadir bucket',
  'integrations.s3Title': 'Conectar S3',
  'integrations.s3Hint': 'Verificamos el acceso escribiendo un archivo marcador .bannermatic-check',
  'integrations.endpointHint': 'Para proveedores distintos de AWS',
  'integrations.publicBase': 'URL base pública (opcional)',
  'integrations.testAndSave': 'Probar y guardar',
  'integrations.connected': 'Conectado',
  'integrations.webhooks': 'Webhooks',
  'integrations.webhooksHint':
    'Notificaciones POST sobre imágenes y lotes finalizados, firmadas con HMAC-SHA256',
  'integrations.defaultWebhook': 'Webhook predeterminado para automatizaciones',
  'integrations.defaultWebhookHint': 'Recibe batch.completed después de cada ejecución',
  'integrations.testWebhook': 'Probar webhook',
  'integrations.send': 'Enviar',
  'integrations.testSent': 'Evento de prueba en cola',
  'integrations.verifyTitle': 'Verifica la firma',
  'integrations.recentDeliveries': 'Entregas recientes',
  'integrations.removeTitle': '¿Quitar la integración?',
  'integrations.removeText': 'Las automatizaciones que la usan no podrán entregar archivos.',
  'settings.tabGeneral': 'General',
  'settings.tabMembers': 'Equipo',
  'settings.tabBilling': 'Facturación',
  'settings.tabProfile': 'Perfil',
  'settings.workspace': 'Espacio de trabajo',
  'settings.dangerZone': 'Zona de peligro',
  'settings.deleteWorkspace': 'Eliminar espacio de trabajo',
  'settings.deleteWorkspaceText':
    'Se eliminarán todas las plantillas, archivos, claves y el historial de generaciones. Esta acción no se puede deshacer.',
  'settings.deleteWorkspaceConfirm': '¿Seguro que quieres eliminar "{name}" con todos sus datos?',
  'settings.lastWorkspace': 'Este es tu único espacio de trabajo, así que no se puede eliminar.',
  'workspace.noneTitle': 'Aún no tienes ningún espacio de trabajo',
  'workspace.noneText':
    'Crea un espacio de trabajo para trabajar con plantillas o pide a tus compañeros que te inviten al suyo.',
  'settings.invite': 'Invitar a compañeros',
  'settings.inviteHint': 'Enviaremos un enlace de invitación por correo.',
  'settings.seats': 'Puestos: {used} de {limit}.',
  'settings.sendInvite': 'Invitar',
  'settings.invited': 'Invitación enviada',
  'settings.inviteLink': 'Enlace',
  'settings.you': 'tú',
  'settings.remove': 'Quitar del equipo',
  'settings.pendingInvites': 'Invitaciones pendientes',
  'settings.expires': 'caduca',
  'settings.rolesTitle': 'Roles',
  'settings.roleOwner': 'todo, incluida la facturación y la eliminación',
  'settings.roleAdmin': 'equipo, claves de API, integraciones',
  'settings.roleEditor': 'plantillas, medios, fuentes, automatizaciones y generación',
  'settings.roleViewer': 'ver plantillas y resultados',
  'settings.language': 'Idioma de la interfaz',
  'settings.changePassword': 'Cambiar contraseña',
  'settings.currentPassword': 'Contraseña actual',
  'settings.passwordChanged': 'Contraseña cambiada',
  'billing.currentPlan': 'Plan actual',
  'billing.renewsOn': 'Se renueva el',
  'billing.endsOn': 'Finaliza el',
  'billing.manage': 'Gestionar suscripción',
  'billing.rendersPeriod': 'Generaciones en este periodo',
  'billing.storage': 'Almacenamiento',
  'billing.plans': 'Planes',
  'billing.monthly': 'Mensual',
  'billing.yearly': 'Anual (−{n}%)',
  'billing.mo': 'mes',
  'billing.popular': 'Popular',
  'billing.current': 'Plan actual',
  'billing.choose': 'Elegir',
  'billing.thanks': '¡Gracias! Tu suscripción se activará en menos de un minuto.',
  'billing.switched': 'Plan cambiado',
  'billing.devMode':
    'Los pagos no están configurados: el modo de desarrollo permite cambiar de plan sin pagar. Conecta Lemon Squeezy (LEMONSQUEEZY_API_KEY) o Stripe (STRIPE_SECRET_KEY) para producción.',
  'billing.noStripe':
    'Los pagos no están configurados en este servidor. Contacta con tu administrador.',
  'billing.fRenders': '{n} generaciones / mes',
  'billing.fTemplates': 'Hasta {n} plantillas',
  'billing.fTemplatesUnlimited': 'Plantillas ilimitadas',
  'billing.fMembers': 'Hasta {n} miembros',
  'billing.fMembersUnlimited': 'Miembros ilimitados',
  'billing.fAutomations': 'Hasta {n} automatizaciones',
  'billing.fAutomationsUnlimited': 'Automatizaciones ilimitadas',
  'billing.fBatch': 'Hasta {n} archivos por ejecución',
  'billing.fFonts': 'Fuentes personalizadas',
  'billing.fIntegrations': 'Google Drive, Sheets, S3',
  'billing.fSigned': 'URL de imagen firmadas',
  'billing.fSchedule': 'Automatizaciones programadas',
  'billing.fNoWatermark': 'Sin marca de agua',
  'landing.navFeatures': 'Funciones',
  'landing.navPricing': 'Precios',
  'landing.navDocs': 'Documentación de la API',
  'landing.login': 'Iniciar sesión',
  'landing.startFree': 'Empezar gratis',
  'landing.openApp': 'Abrir la aplicación',
  'landing.badge': 'Plantillas · Hojas de cálculo · API',
  'landing.title': 'Cientos de banners a partir de una plantilla, en minutos',
  'landing.subtitle':
    'Diseña una plantilla en el editor visual y luego envía textos, fotos, precios y logotipos mediante la API, Google Sheets o CSV. Obtén PNG, JPG, WEBP y PDF.',
  'landing.ctaPrimary': 'Crea tu primera plantilla',
  'landing.ctaSecondary': 'Ver la API',
  'landing.noCard': 'Plan gratuito para siempre. Sin tarjeta de crédito.',
  'landing.demoRows': '{n} filas',
  'landing.uc1': 'Fichas de producto para marketplaces',
  'landing.uc2': 'Anuncios display en todos los tamaños',
  'landing.uc3': 'Publicaciones e historias para redes sociales',
  'landing.uc4': 'Imágenes OG y banners para correo',
  'landing.demo1Title': 'Rebajas de verano',
  'landing.demo1Subtitle': 'Descuentos en toda la colección',
  'landing.demo2Title': 'Nueva colección de zapatillas para correr',
  'landing.demo2Subtitle': 'Ligeras, rápidas, transpirables',
  'landing.demo3Title': 'Black Friday',
  'landing.demo3Subtitle': 'Solo 3 días: date prisa',
  'landing.demo4Title': 'Tarjetas regalo',
  'landing.demo4Subtitle': 'El regalo perfecto para las fiestas',
  'landing.demoFrom': 'desde {price}',
  'landing.uc5': 'Certificados y listas de precios en PDF',
  'landing.featuresTitle': 'Todo para automatizar creatividades',
  'landing.featuresSubtitle':
    'Los diseñadores crean una plantilla una sola vez y las creatividades se montan solas a partir de la API, hojas de cálculo y feeds.',
  'landing.f1Title': 'Editor visual',
  'landing.f1Text':
    'Capas, texto, fotos, logotipos, formas, códigos QR, degradados, sombras, guías inteligentes y texto que se ajusta automáticamente.',
  'landing.f2Title': 'API REST',
  'landing.f2Text':
    'Generación síncrona y asíncrona, lotes de miles de archivos, webhooks firmados y documentación OpenAPI.',
  'landing.f3Title': 'Estudio de automatización',
  'landing.f3Text':
    'CSV, Google Sheets, feeds de productos de Google Merchant, Meta y YML × varias plantillas → ZIP, Google Drive, S3 o webhooks. Programado: solo los productos que cambiaron.',
  'landing.f4Title': 'Tus fuentes',
  'landing.f4Text':
    '40 fuentes populares con cirílico integradas. Sube las fuentes TTF/OTF/WOFF de tu marca y oculta el resto.',
  'landing.f5Title': 'Imágenes y vídeo',
  'landing.f5Text':
    'PNG transparente, JPG, WEBP, PDF vectorial para impresión, retina hasta 3x, y vídeo MP4, WebM y GIF para Reels, TikTok y Shorts.',
  'landing.f6Title': 'Precisión al píxel',
  'landing.f6Text':
    'El editor y el servidor usan el mismo motor de renderizado: lo que ves es lo que obtienes.',
  'landing.howTitle': 'Cómo funciona',
  'landing.step1Title': 'Diseña una plantilla',
  'landing.step1Text':
    'Coloca las capas en el editor y pon nombre a las dinámicas: title, photo, price.',
  'landing.step2Title': 'Conecta los datos',
  'landing.step2Text': 'Envía JSON a la API, sube un CSV o vincula una hoja de Google.',
  'landing.step3Title': 'Obtén los archivos',
  'landing.step3Text':
    'Los archivos llegan como enlaces, en un ZIP, en Drive, en S3 o en tu webhook.',
  'landing.apiTitle': 'Una API fácil de integrar',
  'landing.apiText':
    'Una solicitud, una imagen. O mil en un lote. Funciona desde cualquier lenguaje, n8n, Make y Zapier.',
  'landing.api1': 'Cambia textos, fotos, colores, posiciones y visibilidad por nombre de capa',
  'landing.api2': 'Espera el resultado en la respuesta o recibe un webhook',
  'landing.api3': 'URL firmadas: una imagen desde una URL sin código de servidor',
  'landing.api4': 'Límites, claves y registros de entrega: totalmente transparente',
  'landing.apiCalloutTitle': 'Motor de renderizado automático',
  'landing.apiCalloutText':
    'Pasa parámetros de capas por API, webhooks o tablas: renderizado rápido y paralelo.',
  'landing.pricingTitle': 'Precios sencillos',
  'landing.pricingSubtitle':
    'Paga por el número de imágenes generadas. El editor y la API están en todos los planes.',
  'landing.tryPlan': 'Elegir {plan}',
  'landing.watermark': 'Con marca de agua',
  'landing.faqTitle': 'Preguntas frecuentes',
  'landing.q1': '¿En qué se diferencia de una herramienta de diseño normal?',
  'landing.a1':
    'Una herramienta de diseño normal es para trabajo manual. Bannermatic es para volumen: una plantilla se convierte automáticamente en cientos de variantes mediante la API, hojas de cálculo y programaciones.',
  'landing.q2': '¿Puedo mover elementos, no solo cambiar el texto?',
  'landing.a2':
    'Sí. Para cualquier capa puedes pasar x, y, width, height, rotation y opacity, cambiar su color u ocultarla (hide: true o null), p. ej., {"logo": {"x": 40, "y": 860, "width": 180}}. Las capas dentro de una pila se colocan con el diseño automático: ahí cambias su tamaño y la dirección y el espaciado de la pila, no las coordenadas.',
  'landing.q3': '¿Y si el texto es largo?',
  'landing.a3':
    'Activa el ajuste automático: la fuente se reduce para caber, o limita el número de líneas con puntos suspensivos.',
  'landing.metaTitle':
    'Bannermatic — Generación automatizada de banners mediante API y hojas de cálculo',
  'landing.metaDescription':
    'Editor visual de plantillas y REST API para la generación masiva de banners, tarjetas de productos, creatividades para redes sociales y PDF desde Google Sheets y CSV.',
  'landing.q4': '¿Se admiten el cirílico y las fuentes personalizadas?',
  'landing.a4':
    'Sí, la mayoría de las fuentes integradas incluyen cirílico, y en los planes de pago puedes subir tus propias TTF/OTF/WOFF.',
  'landing.q5': '¿Cómo generar banners desde Google Sheets sin saber programar?',
  'landing.a5':
    'Conecta una hoja de Google Sheets o sube un archivo CSV en el Automation Studio. Las columnas se asignan a las capas de la plantilla (title, price, photo) y Bannermatic genera cientos de banners listos en ZIP, Google Drive o S3.',
  'landing.q6': '¿Es adecuado el servicio para tarjetas de productos en marketplaces?',
  'landing.a6':
    'Sí, es uno de los principales casos de uso. Puedes aplicar en lote etiquetas de descuento, características, precios y logotipos de marcas sobre las fotos de tus productos desde tu feed o catálogo.',
  'landing.finalTitle': 'Deja de hacer banners a mano',
  'landing.finalText': 'Crea una plantilla en 10 minutos y deja la rutina a la API.',
  'landing.navSpreadsheets': 'Hojas de cálculo',
  'landing.tablesBadge': 'Sin código · Estudio de tablas',
  'landing.tablesTitle': 'Banners desde tablas sin código',
  'landing.tablesSubtitle':
    'Conecta una Google Sheet o sube un CSV. Las columnas se asignan automáticamente a las capas de la plantilla, generando cientos de banners con un solo clic.',
  'landing.tablesPoint1Title': 'Importación de Google Sheets y CSV',
  'landing.tablesPoint1Text':
    'Conecta una hoja en línea o arrastra tu archivo de productos. Bannermatic interpreta tus datos al instante.',
  'landing.tablesPoint2Title': 'Mapeo visual de columnas',
  'landing.tablesPoint2Text':
    'Indica qué columna corresponde al título, precio, descuento o foto. El asistente inteligente vincula las capas automáticamente.',
  'landing.tablesPoint3Title': 'Generación por lotes y exportación rápida',
  'landing.tablesPoint3Text':
    'Cientos de banners generados en paralelo en cuestión de segundos. Descarga un archivo ZIP o expórtalo a tu nube.',
  'landing.tablesMascotBubble': '¡Sube tu tabla y listo!',
  'landing.tablesCta': 'Probar el Estudio de automatización',
  'landing.tablesMockSync': 'Sincronizado · 450 filas',
  'landing.tablesMockBtn': 'Generar 450 banners',
  'landing.tablesMockColProduct': 'Producto',
  'landing.tablesMockColPrice': 'Precio',
  'landing.tablesMockColDiscount': 'Descuento',
  'landing.tablesMockColPhoto': 'Foto',
  'landing.tablesMockColStatus': 'Estado',
  'landing.tablesMockDone': 'Listo',
  'automation.autoMapped': 'Columnas emparejadas: {n}',
  'automation.autoMapNone': 'No se encontraron nuevas coincidencias de columnas',
  'automation.matchColumns': 'Emparejar columnas',
  'automation.mediaHint':
    'Las celdas de imagen pueden indicar archivos de la biblioteca de medios:',
  'media.allFiles': 'Todos los archivos',
  'media.noFolder': 'Sin carpeta',
  'media.folders': 'Carpetas',
  'media.newFolder': 'Nueva carpeta',
  'media.renameFolder': 'Renombrar carpeta',
  'media.renameFile': 'Renombrar archivo',
  'media.rename': 'Renombrar',
  'media.moveTo': 'Mover a carpeta',
  'media.moved': 'Archivo movido',
  'media.folderPlaceholder': 'p. ej., Equipos',
  'media.foldersHint':
    'Organiza logotipos y fondos en carpetas: «Equipos», «Ligas»… Arrastra archivos a una carpeta para moverlos.',
  'media.dropInto': 'Suelta los archivos aquí y irán a la carpeta «{folder}»',
  'media.search': 'Buscar por nombre de archivo o carpeta',
  'media.nothingFound': 'No se encontró nada',
  'media.copyRef': 'Copiar referencia para automatizaciones',
  'media.refCopied': 'Copiado: pégalo en una celda de la tabla o en la API',
  'media.refHint': 'En las tablas de automatización y la API, indica un archivo así:',
  'media.exampleFolder': 'Equipos',
  'media.exampleName': 'Arsenal',
  'media.deleteFolderTitle': '¿Eliminar la carpeta «{name}»?',
  'media.deleteFolderText':
    'Sus archivos se conservan y pasan a «Sin carpeta». Las referencias media:Carpeta/… dejarán de encontrarlos.',
  'media.allFolders': 'Todas las carpetas',
  'media.pick': 'Elegir de la biblioteca de medios',
  'err.folderExists': 'Ya existe una carpeta «{name}»',
  'err.nameRequired': 'Introduce un nombre',
  'err.mediaNotFound': 'Capa «{layer}»: «{ref}» no está en la biblioteca de medios',
  'qr.style': 'Estilo del QR',
  'qr.paid':
    'Puntos redondeados, estilo de esquinas, color propio y logotipo en el centro: en Pro y Business.',
  'qr.upgrade': 'Mejorar plan',
  'qr.dots': 'Puntos',
  'qr.eyes': 'Esquinas',
  'qr.eyeColor': 'Color de esquinas',
  'qr.logo': 'Logotipo en el centro',
  'qr.logoHint': 'Disponible en Pro y Business',
  'qr.logoSize': 'Tamaño del logo',
  'qr.logoNote':
    'Con logotipo el código usa la máxima corrección de errores (H): comprueba que se escanea en la vista previa.',
  'qr.dot.square': 'Cuadrados',
  'qr.dot.rounded': 'Redondeados',
  'qr.dot.dots': 'Círculos',
  'qr.eye.square': 'Cuadrado',
  'qr.eye.rounded': 'Redondeado',
  'qr.eye.circle': 'Círculo',
  'billing.fQrStyles': 'Códigos QR con estilo y logotipo',
  'retention.label': 'Se conserva',
  'retention.until': 'hasta el {date}',
  'retention.keptUntil': 'Los archivos se conservan hasta el {date}',
  'retention.batchExpired': 'El periodo de conservación terminó: los archivos se eliminaron',
  'retention.renderExpired': 'El archivo se eliminó tras el periodo de conservación',
  'google.spreadsheet': 'Hoja de cálculo',
  'google.chooseSpreadsheet': 'Elige una hoja',
  'google.noSpreadsheets': 'Aún no hay hojas: elige una en Google Drive o pega un enlace',
  'google.listHint':
    'Google solo muestra a las apps las hojas elegidas con «Google Drive» o ya usadas en automatizaciones.',
  'google.refresh': 'Actualizar la lista',
  'google.fromDrive': 'Google Drive',
  'google.orLink': '…o el enlace de la hoja',
  'google.linkedSheet': 'Hoja del enlace',
  'google.noAccess': 'Esta cuenta de Google no puede abrir la hoja: revisa el enlace y el acceso.',
  'google.noAccessPick':
    'Bannermatic solo ve las hojas elegidas en Google Drive. Ábrela allí una vez: el acceso será solo a este archivo.',
  'google.grantAccess': 'Dar acceso a esta hoja',
  'common.loading': 'Cargando…',
  'common.retry': 'Reintentar',
  'err.pickerOwnerOnly':
    'Solo quien conectó la cuenta de Google (o un administrador) puede explorar su Drive',
  'err.pickerDisabled': 'La selección desde Google Drive no está configurada en el servidor',
  'common.close': 'Cerrar',
  'common.menu': 'Menú',
  'history.title': 'Historial de versiones',
  'history.paid':
    'El historial de la plantilla con restauración de cualquier versión está en el plan Business.',
  'history.restore': 'Restaurar esta versión',
  'history.restored': 'Se restauró la versión del {time}',
  'history.empty': 'Las versiones aparecen tras las primeras ediciones.',
  'history.current': 'Actual',
  'history.restoreOf': 'Restauración a la versión {version}',
  'history.initial': 'Versión original',
  'history.edited': 'Ediciones',
  'history.hint':
    'Las ediciones de una persona en ~10 minutos forman una versión. Se guardan 180 días, hasta 200 por plantilla.',
  'comments.title': 'Comentarios',
  'comments.paid':
    'Los comentarios en plantillas para revisión en equipo están en el plan Business.',
  'comments.empty': 'Aún no hay comentarios. Selecciona una capa para fijar una nota.',
  'comments.resolve': 'Marcar como resuelto',
  'comments.reopen': 'Reabrir',
  'comments.showResolved': 'Mostrar resueltos ({n})',
  'comments.hideResolved': 'Ocultar resueltos',
  'comments.placeholder': 'Una nota o pregunta… (Ctrl+Enter para enviar)',
  'comments.pin': 'A la capa «{layer}»',
  'comments.send': 'Enviar',
  'review.title': 'Aprobación',
  'review.status.draft': 'Borrador',
  'review.status.in_review': 'En revisión',
  'review.status.changes_requested': 'Con cambios pedidos',
  'review.status.approved': 'Aprobada',
  'review.hint.approved': 'Aprobada el {time}. Los cambios de diseño la devuelven a borrador.',
  'review.hint.inReview': 'Espera la decisión del propietario o de un administrador.',
  'review.hint.changes': 'Se pidieron cambios: mira los comentarios de abajo y vuelve a enviarla.',
  'review.hint.edited': 'Cambiada desde que se aprobó.',
  'review.hint.editedRequired':
    'Cambiada desde que se aprobó. La API, las automatizaciones y los enlaces siguen usando la versión aprobada hasta que se apruebe la nueva.',
  'review.hint.draft': 'Cuando el diseño esté listo, envíalo a aprobación.',
  'review.hint.draftRequired':
    'Aún sin aprobar: la API, las automatizaciones y los enlaces no la generan (las vistas previas sí).',
  'review.notePlaceholder': '¿Qué hay que cambiar? La nota va a los comentarios',
  'review.sendBack': 'Devolver',
  'review.approve': 'Aprobar',
  'review.requestChanges': 'Pedir cambios',
  'review.request': 'Enviar a aprobación',
  'review.done.request': 'Enviada a aprobación',
  'review.done.approve': 'Plantilla aprobada',
  'review.done.changes': 'Devuelta para cambios',
  'approval.title': 'Exigir aprobación de plantillas',
  'approval.text':
    'La API, las automatizaciones y los enlaces firmados generan solo la versión aprobada de cada plantilla. Los cambios no llegan a campañas ni feeds hasta que se aprueban. Las vistas previas y la generación del editor funcionan como antes.',
  'approval.on': 'Aprobación obligatoria',
  'approval.off': 'La aprobación ya no es obligatoria',
  'audit.template.review_requested': 'Enviada a aprobación:',
  'audit.template.approved': 'Plantilla aprobada:',
  'audit.template.changes_requested': 'Devuelta para cambios:',
  'err.templateNotApproved':
    'La plantilla «{name}» aún no está aprobada. Apruébala en el editor o desactiva la aprobación obligatoria.',
  'err.reviewAlreadyApproved': 'Esta versión ya está aprobada',
  'activity.tab': 'Actividad',
  'activity.paid':
    'El registro de actividad (quién cambió y ejecutó qué) está en el plan Business. Los eventos ya se registran: tras mejorar verás también los anteriores.',
  'activity.description': 'Quién cambió y ejecutó qué. Se guarda 365 días.',
  'activity.allTypes': 'Todos los eventos',
  'activity.empty': 'Aún no hay eventos',
  'activity.more': 'Mostrar más',
  'activity.times': '×{n}',
  'activity.apiKey': 'Clave API',
  'activity.system': 'Sistema',
  'activity.version': 'versión {n}',
  'activity.renders': '{n} archivos',
  'activity.trigger.manual': 'manualmente',
  'activity.trigger.schedule': 'programado',
  'activity.trigger.api': 'vía API',
  'activity.type.template': 'Plantillas',
  'activity.type.automation': 'Automatizaciones',
  'activity.type.member': 'Equipo',
  'activity.type.api_key': 'Claves API',
  'activity.type.integration': 'Integraciones',
  'activity.type.asset': 'Medios',
  'activity.type.font': 'Fuentes',
  'audit.template.created': 'Plantilla creada:',
  'audit.template.imported': 'Plantilla importada:',
  'audit.template.updated': 'Plantilla editada:',
  'audit.template.deleted': 'Plantilla eliminada:',
  'audit.template.duplicated': 'Copia de plantilla:',
  'audit.template.restored': 'Plantilla restaurada:',
  'audit.comment.added': 'Comentario en',
  'audit.automation.created': 'Automatización creada:',
  'audit.automation.updated': 'Automatización editada:',
  'audit.automation.deleted': 'Automatización eliminada:',
  'audit.automation.run': 'Ejecución de automatización:',
  'audit.batch.created': 'Lote generado vía API',
  'audit.member.invited': 'Invitación enviada a',
  'audit.member.joined': 'Se unió al equipo:',
  'audit.member.removed': 'Eliminado del equipo:',
  'audit.member.left': 'Dejó el equipo:',
  'audit.member.role_changed': 'Rol cambiado para',
  'audit.invitation.revoked': 'Invitación revocada',
  'audit.api_key.created': 'Clave API creada:',
  'audit.api_key.revoked': 'Clave API revocada',
  'audit.integration.connected': 'Integración conectada:',
  'audit.integration.updated': 'Integración reconectada:',
  'audit.integration.deleted': 'Integración eliminada:',
  'audit.asset.uploaded': 'Archivos subidos, el último:',
  'audit.asset.deleted': 'Archivo eliminado:',
  'audit.folder.created': 'Carpeta creada:',
  'audit.folder.deleted': 'Carpeta eliminada:',
  'audit.font.uploaded': 'Fuente subida:',
  'audit.font.deleted': 'Fuente eliminada',
  'audit.motion_preset.created': 'Preset de animación creado:',
  'audit.motion_preset.updated': 'Preset de animación editado:',
  'audit.motion_preset.deleted': 'Preset de animación eliminado:',
  'audit.workspace.updated': 'Ajustes del espacio cambiados:',
  'audit.signing_secret.rotated': 'Secreto de firma renovado',
  'audit.plan.changed': 'Plan cambiado',
  'err.businessFeature': 'Disponible en el plan Business',
  'err.commentEmpty': 'Escribe un comentario',
  'billing.fHistory':
    'Historial de versiones, comentarios, aprobación de plantillas, registro de actividad',
  'brand.title': 'Kit de marca',
  'brand.description':
    'Colores, fuentes y logotipos de la marca se definen una vez: las plantillas los usan por referencia.',
  'brand.create': 'Crear una marca',
  'brand.newName': 'Marca {n}',
  'brand.paid':
    'El kit de marca está en Pro (una marca) y Business (varias marcas, cambio de marca del cliente en automatizaciones y API).',
  'brand.emptyTitle': 'Aún no hay marcas',
  'brand.emptyText': 'Crea una marca y define sus colores, fuentes y logotipos.',
  'brand.moreOnBusiness': 'Varias marcas (para agencias y clientes) en el plan Business.',
  'brand.default': 'Predeterminada',
  'brand.makeDefault': 'Hacer predeterminada',
  'brand.saved': 'Marca guardada: las plantillas se actualizan',
  'brand.colorsTitle': 'Colores',
  'brand.fontsTitle': 'Fuentes',
  'brand.logosTitle': 'Logotipos',
  'brand.deleteTitle': '¿Eliminar la marca «{name}»?',
  'brand.deleteText':
    'Las plantillas que la usan tomarán la marca predeterminada o sus valores de reserva.',
  'brand.howTitle': 'Cómo funciona',
  'brand.howText':
    'En el editor elige un color, fuente o logotipo de la sección de marca: la capa guarda una referencia al hueco («Principal», «Títulos», «Logotipo»), no el valor. Cambia la marca y se actualizan todas las plantillas. Todas las marcas tienen los mismos huecos, así que un juego de plantillas sirve para cualquier cliente: elige la marca en la automatización o pasa brand_id a la API.',
  'brand.colors': 'Colores de marca · {name}',
  'brand.fonts': 'Fuentes de marca · {name}',
  'brand.logos': 'Logotipos de marca · {name}',
  'brand.detach': 'Separar de la marca (mantener el color actual)',
  'brand.useDefault': 'Marca predeterminada ({name})',
  'brand.templateHint':
    'La marca con la que se muestra y genera la plantilla, salvo que la automatización o la API elijan otra.',
  'brand.editorHint':
    'Define una vez los colores, fuentes y logotipos de la marca y úsalos en todas las plantillas.',
  'brand.automationLabel': 'Marca',
  'brand.automationHint':
    'Colores, fuentes y logotipos de marca para todos los banners de la ejecución.',
  'brand.templateBrand': 'La marca de cada plantilla',
  'brand.slot.primary': 'Principal',
  'brand.slot.secondary': 'Secundario',
  'brand.slot.accent': 'Acento',
  'brand.slot.background': 'Fondo',
  'brand.slot.text': 'Texto',
  'brand.slot.font-heading': 'Títulos',
  'brand.slot.font-body': 'Texto',
  'brand.slot.logo': 'Logotipo',
  'brand.slot.logo-light': 'Logotipo claro',
  'brand.slot.logo-icon': 'Icono',
  'err.brandsPlan': 'El kit de marca está disponible en Pro y Business',
  'err.brandsLimit': 'Tu plan permite {limit} marca(s)',
  'err.brandInvalid': 'Revisa los valores de la marca',
  'billing.fBrands': 'Kit de marca',
  'landing.brandDemoTitle': 'Nueva colección',
  'landing.brandDemoSub': 'Solo hasta el domingo',
  'landing.brandsTitle': 'Un juego de plantillas, la marca de cada cliente',
  'landing.brandsSubtitle':
    'Define una vez los colores, fuentes y logotipos. Las plantillas usan el kit de marca: cambia el color corporativo y todos los banners se actualizan. Cambia la marca del cliente en una automatización o con un parámetro de la API.',
  'landing.brandsP1Title': 'Kit de marca',
  'landing.brandsP1Text':
    'Colores, fuentes, logotipos. Una marca en Pro y tantas como quieras en Business, con cambio al vuelo.',
  'landing.brandsP2Title': 'Historial de versiones con restauración',
  'landing.brandsP2Text':
    'Cada sesión de edición se guarda. ¿Rompiste una plantilla antes de lanzarla? Vuelve a la versión anterior con un clic.',
  'landing.brandsP3Title': 'Comentarios y aprobaciones',
  'landing.brandsP3Text':
    'Notas en la capa de la plantilla, estados «en revisión» y «aprobada». La API y las campañas usan solo la versión aprobada: ningún cambio llega a producción sin aprobar.',
  'landing.brandsP4Title': 'Registro de actividad',
  'landing.brandsP4Text':
    'Quién cambió una plantilla, quién lanzó una automatización y con qué clave de API: todo está ahí.',
  'landing.brandsDemoLabel': 'Una plantilla · tres marcas',
  'landing.brandsDemoHint':
    'Es un render en vivo: la misma plantilla con distintos kits de marca: colores, fuentes, acentos.',
  'landing.f7Title': 'Biblioteca de medios con carpetas',
  'landing.f7Text':
    'Logotipos de equipos, fotos de producto, fondos: en carpetas y con búsqueda. En la hoja escribe media:Equipos/Arsenal y se usa el archivo correcto.',
  'landing.f8Title': 'Códigos QR con tu marca',
  'landing.f8Text':
    'Puntos redondeados o círculos, esquinas con estilo y color, logotipo en el centro, y se sigue escaneando.',
  'landing.f9Title': 'La hoja se empareja sola',
  'landing.f9Text':
    'Sube un CSV o elige una hoja de Google de la lista: las columnas se emparejan solas con las capas: «Título», «Home Logo», «Precio».',
  'landing.q7': '¿Puedo llevar varios clientes con marcas distintas?',
  'landing.a7':
    'Sí. En Business crea un kit de marca por cliente: colores, fuentes, logotipos. Las plantillas usan la marca, así que el mismo juego sirve para todos: elige la marca en la automatización o pasa brand_id a la API.',
  'landing.q8': '¿Y si alguien rompe una plantilla?',
  'landing.a8':
    'En Business cada sesión de edición va al historial de versiones: ábrelo, mira la vista previa y restaura cualquier versión con un clic. El registro de actividad muestra quién cambió la plantilla y cuándo.',
  'editor.tabBrand': 'Marca',
  'brandPanel.empty':
    'Aún no hay kit de marca. Añade colores, fuentes y logos y aplícalos con un clic.',
  'brandPanel.toSelection': 'a las capas seleccionadas ({n})',
  'brandPanel.toBackground': 'al fondo del lienzo',
  'brandPanel.linked': 'Vinculado a la marca: {n}',
  'brandPanel.nothingToLink': 'Ningún color ni fuente de la plantilla coincide con la marca',
  'brandPanel.edit': 'Editar kit de marca',
  'brandPanel.clickHint':
    'Haz clic en un color para aplicarlo {target}. El valor queda vinculado a la marca.',
  'brandPanel.fontHint':
    'Haz clic para aplicarla al texto seleccionado o añadir texto nuevo con esta fuente',
  'brandPanel.logoHint': 'Haz clic para sustituir la imagen seleccionada o añadir el logo',
  'brandPanel.linkAll': 'Vincular plantilla a la marca',
  'brandPanel.linkAllHint':
    'Busca en la plantilla los colores, fuentes y logos de la marca y los vincula, así otra marca cambia todo el banner.',
  'brandImport.open': 'Importar',
  'brandImport.title': 'Importar kit de marca',
  'brandImport.description':
    'Reuniremos colores, fuentes y logos de un sitio web o un archivo de Figma.',
  'brandImport.reviewHint': 'Revisa lo que encontramos y ajústalo si hace falta.',
  'brandImport.back': 'Atrás',
  'brandImport.replace': 'Actualizar marca',
  'brandImport.create': 'Crear marca',
  'brandImport.website': 'Sitio web',
  'brandImport.siteLabel': 'Dirección del sitio',
  'brandImport.siteHint':
    'Tomamos los colores del CSS, las fuentes y el logo de la página principal.',
  'brandImport.find': 'Buscar',
  'brandImport.figmaConnect': 'Conecta Figma para leer los estilos y variables del archivo.',
  'brandImport.figmaStep1':
    'En Figma: Settings → Security → Personal access tokens → Generate new token (lectura de archivos).',
  'brandImport.figmaStep2': 'Pega el token abajo. Se guarda cifrado.',
  'brandImport.connect': 'Conectar',
  'brandImport.figmaLabel': 'Enlace al archivo de Figma',
  'brandImport.figmaHint':
    'Mejor un archivo de sistema de diseño: estilos de color y texto, logos como componentes.',
  'brandImport.reading': 'Leyendo la fuente…',
  'brandImport.name': 'Nombre de la marca',
  'brandImport.saveTo': 'Guardar como',
  'brandImport.newBrand': 'Marca nueva',
  'brandImport.replaceBrand': 'Reemplazar «{name}»',
  'brandImport.pickFor': 'Elige un color',
  'brandImport.paletteHint':
    'Paleta encontrada: haz clic para asignar un color a la ranura elegida',
  'brandImport.fontMissing':
    '«{family}» no está en la biblioteca: elige una similar o sube el archivo de la fuente.',
  'brandImport.noLogos': 'No se encontraron logos. Puedes añadirlos más tarde.',
  'brandImport.skipLogo': 'No importar',
  'brandImport.saved': 'Kit de marca importado',
  'integrations.figmaHint': 'Importa kits de marca desde estilos y variables de archivos de Figma.',
  'err.siteHttp': 'El sitio respondió con HTTP {status}.',
  'err.figmaLink': 'No parece un enlace a un archivo de Figma.',
  'err.figmaToken': 'Pega un token de Figma.',
  'err.figmaNotFound': 'No se encontró el archivo de Figma. Revisa el enlace.',
  'err.figmaForbidden': 'Sin acceso: el token no es válido o la cuenta no puede abrir el archivo.',
  'err.figmaError': 'Figma devolvió un error. Inténtalo más tarde.',
  'brandDs.onPage': 'En esta página',
  'brandDs.overview': 'Resumen',
  'brandDs.typography': 'Tipografía',
  'brandDs.usage': 'En uso',
  'brandDs.tagline': 'Colores, fuentes y logos de la marca en cada banner',
  'brandDs.colorsHint':
    'Haz clic en una muestra para elegir color o escribe un HEX. Las plantillas usan la ranura (token), no el valor, así que cambiar un color cambia todos los banners.',
  'brandDs.notSet': 'Sin definir',
  'brandDs.contrast': 'Contraste de pares',
  'brandDs.contrastHint':
    'Legibilidad según WCAG: AA desde 4.5, AAA desde 7, 3+ solo para texto grande.',
  'brandDs.pairSample': 'Rebajas −30%',
  'brandDs.largeOnly': 'grande',
  'brandDs.fail': 'bajo',
  'brandDs.typeHint':
    'Fuentes de títulos y texto. Las capas con fuente de marca cambian junto con el kit.',
  'brandDs.sampleHeadline': 'Un banner llamativo en segundos',
  'brandDs.sampleBody':
    'Las plantillas toman colores, fuentes y logos del kit, así cada render luce de marca.',
  'brandDs.logosHint':
    'Logo principal para fondos claros, el claro para oscuros (sobre el color principal), el icono para formatos pequeños.',
  'brandDs.usageHint':
    'Así lucen las plantillas vinculadas con este kit. La vista previa refleja al instante los cambios sin guardar.',
  'brandDs.sampleCta': 'Comprar',
  'brandDs.unsaved': 'Tienes cambios sin guardar',
  'brandDs.discard': 'Descartar',
  'keys.title': 'Atajos de teclado',
  'keys.description':
    'Funcionan con el foco en el lienzo. Las teclas de letras funcionan con cualquier distribución.',
  'keys.general': 'General',
  'keys.layers': 'Capas',
  'keys.animation': 'Animación',
  'keys.playPause': 'Reproducir / pausa',
  'keys.frameStep': 'Fotograma atrás / adelante',
  'keys.secondStep': 'Segundo atrás / adelante',
  'keys.toStartEnd': 'Al inicio / final',
  'keys.view': 'Vista',
  'keys.tools': 'Herramientas',
  'keys.save': 'Guardar',
  'keys.cut': 'Cortar',
  'keys.selectAll': 'Seleccionar todo',
  'keys.delete': 'Eliminar',
  'keys.deselect': 'Deseleccionar / salir de la pila',
  'keys.editText': 'Editar texto',
  'keys.dblclick': 'doble clic',
  'keys.cheatsheet': 'Esta chuleta',
  'editor.panelLeft': 'el panel de capas',
  'editor.panelRight': 'el panel de propiedades',
  'editor.panelBottom': 'la línea de tiempo y el guion gráfico',
  'editor.panelShow': 'Mostrar {panel}',
  'editor.panelHide': 'Ocultar {panel}',
  'editor.focus': 'Foco en la vista previa: ocultar todos los paneles',
  'editor.focusExit': 'Volver a mostrar los paneles',
  'editor.panels': 'Paneles',
  'editor.timelineResize': 'Arrastra para cambiar la altura',
  'keys.nudge': 'Mover 1 px',
  'keys.nudge10': 'Mover 10 px',
  'keys.forward': 'Traer adelante',
  'keys.backward': 'Enviar atrás',
  'keys.front': 'Traer al frente',
  'keys.back': 'Enviar al fondo',
  'keys.hideShow': 'Ocultar / mostrar',
  'keys.lockUnlock': 'Bloquear / desbloquear',
  'keys.keepRatio': 'Mantener proporciones',
  'keys.rotateStep': 'Girar en pasos de 15°',
  'keys.distances': 'Distancias a los vecinos',
  'keys.drag': 'arrastrar',
  'keys.rotate': 'girar',
  'keys.wheel': 'rueda',
  'keys.zoomWheel': 'Zoom en el cursor',
  'keys.pan': 'Desplazar el lienzo',
  'keys.select': 'Selección',
  'keys.body': 'Texto',
  'plan.from': 'Disponible desde el plan {plan}',
  'templates.placidFonts':
    'No se pudieron descargar las fuentes: {fonts}. Las capas ya las usan; sube los archivos en Fuentes.',
  'templates.placidImages': '{n} imágenes siguen enlazadas a Placid: no se pudieron descargar.',
  'templates.placidSkipped': 'Elementos no compatibles omitidos: {types}',
  'templates.badJson': 'El archivo no es un JSON válido',
  'err.placidFormat': 'El archivo no parece una exportación de plantilla de Placid',
  'consent.title': 'Usamos cookies',
  'consent.text':
    'Las cookies esenciales mantienen tu sesión. Con tu consentimiento también usamos Google Analytics para mejorar el servicio. Sin cookies publicitarias.',
  'consent.accept': 'Aceptar todas',
  'consent.essentialOnly': 'Solo esenciales',
  'consent.customize': 'Personalizar',
  'consent.save': 'Guardar elección',
  'consent.settingsTitle': 'Configuración de cookies',
  'consent.settingsText':
    'Elige qué permitir. Puedes cambiarlo cuando quieras desde el pie de página o tu perfil.',
  'consent.essential': 'Esenciales',
  'consent.essentialText':
    'Sesión, protección contra falsificación de solicitudes, idioma y espacio elegido. El servicio no funciona sin ellas.',
  'consent.always': 'Siempre activas',
  'consent.analytics': 'Analítica (Google Analytics)',
  'consent.analyticsText':
    'Estadísticas seudónimas de visitas: qué páginas se abren y de dónde vienen. Las cookies _ga duran hasta 2 años; Google guarda los datos 14 meses.',
  'consent.more': 'Más en la',
  'consent.link': 'Configuración de cookies',
  'privacy.title': 'Privacidad y datos',
  'privacy.text': 'Descarga una copia de tus datos, cambia las cookies o elimina tu cuenta.',
  'privacy.export': 'Descargar mis datos',
  'privacy.delete': 'Eliminar cuenta',
  'privacy.deleteTitle': '¿Eliminar tu cuenta para siempre?',
  'privacy.deleteText':
    'Tu cuenta, tus datos y los espacios que solo usas tú (con plantillas y archivos) se eliminarán para siempre. Antes puedes descargar una copia.',
  'privacy.deleteConfirm': 'Eliminar para siempre',
  'privacy.blocked': 'Primero resuelve estos espacios:',
  'privacy.blocker.transferOwnership':
    'eres el único propietario y tiene miembros: nombra a otro propietario',
  'privacy.blocker.cancelSubscription': 'suscripción activa: cancélala en Plan y pago',
  'privacy.willDelete': 'Se eliminarán los espacios:',
  'privacy.willLeave': 'Saldrás de:',
  'privacy.typeEmail': 'Escribe {email} para confirmar',
  'err.confirmEmail': 'Escribe tu email para confirmar',
  'brandDs.sampleQuote': 'Lanzamos 300 banners de rebajas en una tarde, todos con nuestro estilo.',
  'brandDs.sampleAuthor': 'Anna Koval',
  'brandDs.sampleRole': 'Directora de arte',
  'brandDs.sampleDate': '24 mayo',
  'brandDs.samplePlace': 'Online · 19:00',
  'brandDs.sampleNew': 'Nuevo',
  'preview.fake': 'Datos aleatorios',
  'preview.fakeRun': 'Aleatorio y renderizar',
  'preview.fakeHint':
    'Los textos se eligen por el nombre de la capa (price, date, team, title…); las fotos son imágenes gratuitas de Unsplash vía Lorem Picsum y los logos de DiceBear.',
  'gallery.cat.sport': 'Partidos y torneos',
  'fonts.cat.all': 'Todas',
  'fonts.cat.sans-serif': 'Sans',
  'fonts.cat.serif': 'Serif',
  'fonts.cat.display': 'Display',
  'fonts.cat.handwriting': 'Manuscritas',
  'fonts.cat.monospace': 'Mono',
  'stock.myFiles': 'Mis archivos',
  'stock.photos': 'Fotos de Unsplash',
  'stock.search': 'Busca fotos gratis (mejor en inglés)',
  'stock.more': 'Más fotos',
  'stock.error': 'No se pudieron cargar las fotos. Inténtalo más tarde.',
  'stock.credit':
    'Fotos gratuitas para uso comercial; el autor se indica en la descripción de la capa. Fuente:',
  'stock.idea.coffee': 'coffee',
  'stock.idea.city': 'city night',
  'stock.idea.sport': 'football stadium',
  'stock.idea.food': 'food flat lay',
  'stock.idea.nature': 'mountains',
  'stock.idea.people': 'smiling woman',
  'err.stockOff': 'La búsqueda de fotos no está configurada',
  'err.stockLimit': 'Se alcanzó el límite de Unsplash, inténtalo más tarde',
  'err.stockError': 'Unsplash devolvió un error',
  'motion.mode': 'Animación',
  'motion.modeHint': 'Anima la plantilla para vídeos, GIF y banners animados',
  'motion.back': 'Volver al diseño',
  'motion.tabDesign': 'Diseño',
  'motion.tabDesignHint':
    'Texto, fuente, colores y tamaño de la capa, directamente en la animación. Doble clic en un texto de la escena para editarlo ahí mismo',
  'motion.tabMotion': 'Animación',
  'motion.sceneGraphics': 'Gráficos animados de la escena',
  'motion.sceneGraphicsHint': 'Abrir en la animación para editar su texto y ajustes',
  'motion.play': 'Reproducir',
  'motion.pause': 'Pausa',
  'motion.animate': 'Animar',
  'motion.animateHint':
    'Anima todas las capas con el estilo elegido. Se reemplazan los ajustes manuales.',
  'motion.style': 'Estilo de movimiento',
  'motion.clear': 'Quitar animación',
  'motion.empty':
    'La plantilla aún es estática. Elige un estilo y pulsa «Animar» o configura cada capa.',
  'motion.video': 'Vídeo',
  'motion.duration': 'Duración',
  'motion.fps': 'FPS',
  'motion.loops': 'Repeticiones del banner',
  'motion.forever': 'Infinito',
  'motion.scenes': 'Escenas',
  'motion.scenesHint':
    'Las escenas se suceden como los fotogramas de un banner HTML5. Las capas sin escena siguen en pantalla.',
  'motion.addScene': 'Añadir escena',
  'motion.sceneN': 'Escena {n}',
  'motion.transition': 'Transición',
  'motion.none': 'Ninguna',
  'motion.enter': 'Entrada',
  'motion.emphasis': 'Énfasis',
  'motion.exit': 'Salida',
  'motion.delay': 'Retraso',
  'motion.beforeEnd': 'Antes del final',
  'motion.length': 'Duración',
  'motion.easing': 'Curva',
  'motion.easingDefault': 'La del preset',
  'motion.repeat': 'Repeticiones',
  'motion.repeatHint': '0 = hasta el final de la escena',
  'motion.gap': 'Pausa',
  'motion.split': 'Texto por partes',
  'motion.split_none': 'Entero',
  'motion.split_line': 'Líneas',
  'motion.split_word': 'Palabras',
  'motion.split_char': 'Letras',
  'motion.stagger': 'Escalonado',
  'motion.order': 'Orden',
  'motion.order_start': 'Desde el inicio',
  'motion.order_end': 'Desde el final',
  'motion.order_center': 'Desde el centro',
  'motion.order_edges': 'Desde los bordes',
  'motion.order_random': 'Aleatorio',
  'motion.scene': 'Escena',
  'motion.wholeVideo': 'Todo el vídeo',
  'motion.layerHint':
    'Selecciona una capa en la lista o en la línea de tiempo para configurar su movimiento.',
  'motion.dir_up': 'Arriba',
  'motion.dir_down': 'Abajo',
  'motion.dir_left': 'Izquierda',
  'motion.dir_right': 'Derecha',
  'motion.sec': 's',
  'motion.opener': 'Inicio',
  'motion.layerStyle': 'Movimiento de capas',
  'motion.noOpener': 'Sin apertura',
  'motion.pickHint':
    'La apertura, el movimiento de capas, los acentos y el final se complementan; la elección se aplica al instante.',
  'motion.openerPickHint':
    'Gráficos al inicio del vídeo, sobre tu diseño. Pasa el ratón para reproducir.',
  'motion.stylePickHint': 'Cómo entran y se mueven las capas. Pasa el ratón para reproducir.',
  'motion.outro': 'Final',
  'motion.noOutro': 'Sin final',
  'motion.outroPickHint':
    'Cómo termina el vídeo: cartela con la llamada, foco en la oferta, bucle. Pasa el ratón para reproducir.',
  'motion.accents': 'Acentos',
  'motion.accentsHint':
    'Momentos en mitad del vídeo, ligados a elementos. Sin su elemento, el acento no hace nada.',
  'motion.customBadge': 'Tuyo',
  'motion.deletePresetTitle': '¿Eliminar el preset?',
  'motion.deletePresetText':
    'El preset sale de las listas. Las plantillas ya animadas con él no cambian: guardan su propia copia.',
  'motion.soundBarHint':
    'Arrastra para mover; los bordes recortan el inicio y el final; con Shift el sonido se desliza dentro del tramo; Alt ignora el ritmo',
  'motion.splitSound': 'Cortar',
  'motion.splitSoundHint': 'Cortar el sonido en el cabezal (S)',
  'motion.splitSoundOutside': 'Pon el cabezal dentro del sonido elegido',
  'motion.removeSound': 'Quitar el sonido',
  'motion.oneScene': 'una',
  'admin.settings': 'Ajustes',
  'admin.settingsSaved': 'Guardado',
  'backup.tab': 'Traslado de servidor',
  'backup.exportTitle': 'Descargar una copia de seguridad',
  'backup.exportText':
    'Un ZIP con toda la base de datos (usuarios, espacios, plantillas, automatizaciones, integraciones, historial) y todos los archivos. Súbelo en el panel de administración del nuevo servidor.',
  'backup.includeFiles': 'Con archivos (desmárcalo si ambos servidores usan el mismo S3)',
  'backup.download': 'Descargar copia',
  'backup.importTitle': 'Restaurar desde una copia',
  'backup.importText':
    'Sustituye todos los datos de este servidor por los de la copia. La versión de Bannermatic y ENCRYPTION_KEY deben coincidir con el servidor antiguo. Las cuentas y sesiones se trasladan con la base de datos.',
  'backup.chooseFile': 'Elegir el ZIP',
  'backup.restore': 'Restaurar',
  'backup.confirmTitle': '¿Sustituir todos los datos de este servidor?',
  'backup.confirmText':
    'Todos los usuarios, plantillas y ajustes se sustituirán por la copia. No se puede deshacer.',
  'backup.keyHint':
    'ENCRYPTION_KEY es distinto aquí: las cuentas de Google conectadas, S3 y otros secretos no se abrirán. Mejor copia ENCRYPTION_KEY del servidor antiguo y reinicia este.',
  'backup.ignoreKey': 'Restaurar igualmente (habrá que volver a conectar las integraciones)',
  'backup.restored':
    'Restaurado: {users} usuarios, {files} archivos. Si te pide iniciar sesión, usa tu cuenta del servidor antiguo.',
  'err.backupInvalid': 'Esto no es una copia de Bannermatic.',
  'err.backupVersion':
    'La copia es de otra versión de Bannermatic. Actualiza primero ambos servidores a la misma versión.',
  'err.backupKey': 'ENCRYPTION_KEY es distinto al del servidor antiguo.',
  'admin.serverVideo': 'Render de vídeo en el servidor',
  'admin.serverVideoPlans': 'Planes que pueden generar vídeo en el servidor',
  'admin.serverVideoPlansHint':
    'Los demás planes generan vídeo solo en el navegador del usuario, aunque el render en el servidor esté activado.',
  'admin.serverVideoOffHint':
    'Desactivado para todos. Los vídeos (MP4, WebM, GIF) se renderizan solo en el ordenador del usuario, en el editor. La API y las automatizaciones con formatos de vídeo reciben un error; las imágenes funcionan con normalidad.',
  'admin.serverVideoOnHint':
    'Activado para todos. Los vídeos se renderizan en tus servidores: desde el editor, la API y las automatizaciones. Un clip de 5 s 1080×1080 cuesta unos 20 vCPU·s.',
  'browserRender.serverOffNoDevice':
    'Por ahora los vídeos solo se renderizan en el ordenador del usuario y este navegador no puede. Abre el editor en Chrome o Edge en un ordenador.',
  'automation.serverVideoOff':
    'Los formatos de vídeo no están disponibles: el render de vídeo en el servidor está desactivado por ahora. Haz vídeos en el editor con el botón «Generar».',
  'err.serverVideoOff':
    'El render de vídeo en el servidor está desactivado. Haz el vídeo en el editor: «Generar» → en este ordenador.',
  'resize.videoFormats': 'Formatos para redes sociales',
  'motion.easingHint':
    'Cómo cambia la velocidad del movimiento: el tiempo en horizontal, el recorrido en vertical. Pasa el ratón para verlo.',
  'video.galleryHint':
    'Vídeos publicitarios listos con escenas, transiciones y montaje. Pasa el ratón por una tarjeta para verla, elige el formato y cambia las fotos y los textos.',
  'video.hoverToPlay': 'Pasa el ratón para reproducir',
  'video.cat.basic': 'Estructuras básicas',
  'video.cat.sale': 'Rebajas',
  'video.cat.product': 'Producto',
  'video.cat.fashion': 'Moda',
  'video.cat.food': 'Comida',
  'video.cat.realestate': 'Inmobiliaria',
  'video.cat.travel': 'Viajes',
  'video.cat.fitness': 'Fitness',
  'video.cat.event': 'Eventos',
  'video.cat.tech': 'Apps y tecnología',
  'video.cat.beauty': 'Belleza',
  'video.cat.auto': 'Motor',
  'video.cat.hiring': 'Empleo',
  'video.cat.holiday': 'Fiestas',
  'video.cat.social': 'Redes y reseñas',
  'video.cat.motion': 'Motion design',
  'api.videoHelp':
    'vídeos y plantillas animadas (tardan más: usa ?wait=false y webhook_url). Una capa de imagen acepta un enlace .mp4/.mov/.webm y reproduce el clip; recorte: video_start, video_end (s), video_speed, video_muted.',
  'api.motionStyleHelp':
    'anima la plantilla con un estilo (smooth, energetic, elegant, kinetic, sale…); sin él se usa la animación de la plantilla.',
  'api.soundHelp':
    'música y locución del vídeo: enlace al archivo, null para quitarla o { url, volume, start, fade_out }.',
  'automation.videoFormatsHint':
    'MP4, WEBM y GIF renderizan vídeos y animaciones. Una plantilla estática recibe una animación suave automáticamente.',
  'motion.zoom': 'Zoom de la línea de tiempo',
  'motion.zoomIn': 'Acercar',
  'motion.zoomOut': 'Alejar',
  'motion.zoomFit': 'Vídeo completo',
  'motion.zoomHint': 'Zoom: Ctrl + rueda del ratón. Desplazar de lado: Shift + rueda',
  'templates.filterBanners': 'Banners',
  'templates.filterVideos': 'Vídeos',
  'templates.kindVideo': 'Vídeo',
  'templates.kindAnimated': 'Animado',
  'templates.scenes': '{n} escenas',
  'story.openHint': 'Clic: ir a la escena. Doble clic o el lápiz: abrirla en el diseño',
  'story.editDesign': 'Editar diseño de la escena',
  'sound.micInsecure':
    'El navegador solo da el micrófono a sitios https o localhost. Abre el editor por https.',
  'sound.micMissing': 'No se encontró ningún micrófono. Conéctalo y vuelve a intentarlo.',
  'video.new': 'Nuevo vídeo',
  'video.fmt.vertical': 'Reels, TikTok, Shorts',
  'video.fmt.portrait': 'Feed, 4:5',
  'video.fmt.square': 'Cuadrado',
  'video.fmt.wide': 'YouTube, web',
  'video.recipe.sale': 'Rebajas',
  'video.recipe.saleHint': 'Gancho, producto, precio rebajado, llamada a la acción',
  'video.recipe.launch': 'Lanzamiento',
  'video.recipe.launchHint': 'Gancho, producto, tres ventajas, llamada a la acción',
  'video.recipe.review': 'Reseña',
  'video.recipe.reviewHint': 'Cita de cliente, producto, ventajas, llamada a la acción',
  'video.recipe.event': 'Evento',
  'video.recipe.eventHint': 'Gancho, fecha y lugar, qué habrá, llamada a la acción',
  'video.scene.hook': 'Gancho',
  'video.scene.product': 'Producto',
  'video.scene.offer': 'Oferta',
  'video.scene.benefits': 'Ventajas',
  'video.scene.quote': 'Reseña',
  'video.scene.when': 'Cuándo y dónde',
  'video.scene.cta': 'Llamada',
  'video.txt.hook.sale': '¡Solo 3 días!',
  'video.txt.hook.launch': 'Conoce la novedad',
  'video.txt.hook.event': '¡No te lo pierdas!',
  'video.txt.product': 'Nombre del producto',
  'video.txt.oldPrice': '59 €',
  'video.txt.price': '29 €',
  'video.txt.benefit1': 'Envío gratis',
  'video.txt.benefit2': 'Devolución fácil',
  'video.txt.benefit3': 'Más de 10.000 clientes nos eligen',
  'video.txt.quote': '«La mejor compra del año»',
  'video.txt.author': 'Ana, clienta',
  'video.txt.date': '12 de junio · 19:00',
  'video.txt.place': 'Online',
  'video.txt.cta.sale': 'Comprar con descuento',
  'video.txt.cta.launch': 'Más información',
  'video.txt.cta.review': 'Pruébalo',
  'video.txt.cta.event': 'Regístrate',
  'safe.hint': 'Zonas seguras: donde la app tapa el vídeo con botones y texto',
  'safe.off': 'Sin zonas',
  'safe.zone': 'Zonas de {app}',
  'sound.title': 'Voz y sonidos',
  'sound.record': 'Grabar voz',
  'sound.stop': 'Parar',
  'sound.upload': 'Subir audio',
  'sound.hint':
    'Voz en off, efectos, una segunda melodía. Empiezan en el cursor y la música baja bajo la voz.',
  'sound.recordingHint':
    'Grabando junto al vídeo. Con auriculares el micrófono no capta la música.',
  'sound.micDenied':
    'Sin acceso al micrófono. Pulsa el candado a la izquierda de la dirección, permite el micrófono y vuelve a intentarlo.',
  'sound.start': 'Inicio',
  'sound.here': 'Al cursor',
  'sound.toPlayhead': 'Empezar en el cursor',
  'sound.duck': 'Música bajo la voz',
  'sound.kind.voice': 'Voz',
  'sound.kind.music': 'Música',
  'sound.kind.sfx': 'Efecto',
  'editor.videoSpeed': 'Velocidad',
  'editor.videoFitScene': 'Ajustar la escena al clip ({s} s)',
  'story.title': 'Guion gráfico',
  'story.emptyHint':
    'Divide el vídeo en escenas: gancho, producto, beneficios, oferta, llamada a la acción.',
  'story.make': 'Dividir en escenas',
  'story.add': 'Escena',
  'story.split': 'Cortar aquí',
  'story.addAfter': 'Nueva escena después de esta',
  'story.moveEarlier': 'Mover antes',
  'story.moveLater': 'Mover después',
  'story.cut': 'Corte',
  'story.toAll': 'Mostrar en todas las escenas',
  'story.toScene': 'En todas las escenas. Haz clic para dejarla solo en esta',
  'err.browserRenderPlan': 'El render en tu ordenador no está disponible en este plan.',
  'billing.fVideo': 'Vídeo: {n} min al mes ({m} min en tu ordenador)',
  'billing.videoPeriod': 'Vídeo en el periodo actual',
  'billing.videoMin': '{n} min',
  'err.videoLimit':
    'Has agotado el límite mensual de vídeo ({used} de {limit} s en el plan {plan}). El render en tu ordenador consume el límite 4 veces más despacio.',
  'browserRender.optionHint':
    'El vídeo se dibuja y codifica en tu navegador. Consume cuatro veces menos límite de vídeo que un render en el servidor.',
  'preview.deviceFree':
    'Más barato: renderizar en tu ordenador consume 4 veces menos límite de vídeo.',
  'videoGen.title': 'Vídeo con tu contenido',
  'videoGen.hint': 'tus textos, fotos y marca — vídeos nuevos cada vez',
  'videoGen.headline': 'Titular',
  'videoGen.brandName': 'Nombre de marca o producto',
  'videoGen.subline': 'Subtítulo',
  'videoGen.benefits': 'Ventajas',
  'videoGen.perLine': 'Uno por línea, hasta 5',
  'videoGen.stats': 'Cifras',
  'videoGen.statsHint': '«12k — suscriptores», una por línea',
  'videoGen.more': 'Oferta, precio, reseña, botón',
  'videoGen.offer': 'Oferta (−30%, 2x1)',
  'videoGen.offerNote': 'Nota de la oferta',
  'videoGen.price': 'Precio',
  'videoGen.oldPrice': 'Precio anterior',
  'videoGen.quote': 'Reseña',
  'videoGen.author': 'Autor de la reseña',
  'videoGen.cta': 'Texto del botón',
  'videoGen.site': 'Web o cuenta',
  'videoGen.brandKit': 'Kit de marca',
  'videoGen.brandKitHint': 'Colores, fuentes y logo de la marca',
  'videoGen.noBrand': 'Sin marca — paleta aleatoria',
  'videoGen.logo': 'Logo',
  'videoGen.noLogo': 'Sin logo',
  'videoGen.logoBrand': 'Del kit de marca',
  'videoGen.photos': 'Fotos',
  'videoGen.photosHint': '{n} seleccionadas · de la biblioteca o sube las tuyas',
  'videoGen.generate': 'Generar vídeos',
  'videoGen.again': 'Más variantes',
  'videoGen.needHeadline': 'Hace falta un titular',
  'videoGen.variant': 'variante {n}',
  'browserRender.option': 'En este ordenador (beta)',
  'browserRender.title': 'Render en este ordenador',
  'browserRender.prepare': 'Preparando la escena…',
  'browserRender.sound': 'Mezclando el sonido…',
  'browserRender.frames': 'Fotograma {n} de {total}',
  'browserRender.paused': 'En pausa: la pestaña está oculta. Vuelve a ella para continuar.',
  'browserRender.finish': 'Guardando el vídeo…',
  'browserRender.keepOpen': 'No cierres ni minimices la pestaña mientras se renderiza.',
  'browserRender.speed': 'La velocidad depende de tu ordenador.',
  'browserRender.differs': 'El resultado puede diferir un poco del render en el servidor.',
  'browserRender.cancelled': 'Render cancelado',
  'motion.music': 'Música',
  'motion.noMusic': 'Sin música',
  'motion.musicUpload': 'Subir una pista (MP3, M4A, WAV, OGG, FLAC)',
  'motion.musicHint':
    'Sube una pista y detectamos su tempo: Animar pone los movimientos al ritmo y el sonido va en MP4 y WEBM.',
  'motion.musicStart': 'Desfase canción',
  'motion.musicAt': 'Inicio',
  'motion.musicAtHint': 'Cuándo empieza a sonar la música en el vídeo',
  'motion.musicLength': 'Duración',
  'motion.musicLengthHint': 'Cuánto suena la música. Hasta el final del vídeo: crece con el vídeo',
  'motion.bpmHint':
    'Tempo de la pista en pulsos por minuto. Detectado automáticamente, se puede corregir; 0 desactiva la rejilla.',
  'motion.fadeIn': 'Entrada',
  'motion.fadeOut': 'Salida',
  'motion.beatSync': 'Animar al ritmo',
  'motion.syncNow': 'Ajustar al ritmo',
  'motion.noBeat': 'No se encontró un ritmo estable. Indica el BPM a mano si lo tiene.',
  'err.audioUnreadable': 'No se pudo leer el audio: sube un MP3, M4A, WAV, OGG o FLAC.',
  'motion.beats': 'Pulsos',
  'motion.keys': 'Fotogramas clave',
  'motion.keysHint':
    'Coloca el cabezal y arrastra la capa en el escenario para grabar un fotograma. Arrástrala en otro momento y la capa se moverá entre ellos.',
  'motion.keyScale': 'Escala',
  'motion.keyRotate': 'Giro',
  'motion.keyOpacity': 'Opacidad',
  'motion.keyEasing': 'Hasta el siguiente',
  'motion.keyDelete': 'Borrar fotograma',
  'motion.keyAdd': 'Fotograma aquí',
  'motion.keysClear': 'Quitar todos',
  'motion.openers': 'Aperturas',
  'motion.styles': 'Estilos de movimiento',
  'motion.fx': 'Gráficos',
  'motion.fxHint':
    'Paneles, círculos, confeti, títulos y fondos sobre o bajo el diseño. Los colores salen de la plantilla.',
  'motion.addFx': '+ Añadir gráfico',
  'motion.camera': 'Cámara',
  'motion.cameraHint': 'Movimientos de toda la composición: acercar, alejar, sacudir, panear.',
  'motion.addCamera': '+ Añadir movimiento de cámara',
  'motion.start': 'Inicio',
  'motion.zLayer': 'Dónde',
  'motion.zFront': 'Sobre el diseño',
  'motion.zBack': 'Bajo las capas (fondo)',
  'motion.auto': 'Automático',
  'motion.color_accent': 'Acento de la plantilla',
  'motion.color_accent2': 'Segundo acento',
  'motion.color_dark': 'Oscuro',
  'motion.color_light': 'Claro',
  'motion.color_ink': 'Contraste con el fondo',
  'motion.color_custom': 'Color propio',
  'motion.fxcat_text': 'Títulos',
  'motion.fxcat_cover': 'Cortinas',
  'motion.fxcat_accent': 'Acentos',
  'motion.fxcat_ambient': 'Fondos',
  'motion.keyBlur': 'Desenfoque',
  'sound.auto': 'Sonorizar automáticamente',
  'sound.autoAgain': 'Recolocar efectos',
  'sound.autoClear': 'Quitar efectos automáticos',
  'sound.autoHint':
    'Zumbido 0,4 s antes de una transición, golpe en un corte, tic por cada letra que aterriza, tecleo para terminales y más. Tus sonidos se mantienen.',
  'sound.addSfx': 'Efecto',
  'sound.generateMusic': 'Generar música',
  'sound.listen': 'Escuchar una toma',
  'sound.anotherTake': 'Otra toma',
  'sound.useTake': 'Usar',
  'sound.bpmAuto': '0 — el estilo elige el tempo',
  'sound.energy_calm': 'Tranquila',
  'sound.energy_normal': 'Normal',
  'sound.energy_high': 'Enérgica',
  'sound.generateMusicHint':
    'Cada toma es una pieza nueva: tonalidad, groove, bajo, melodía, intro, drop y break; los platillos caen en los cortes del vídeo. Libre de derechos.',
  'motion.fontAuto': 'Como la capa o el título',
  'motion.fontReset': 'Restablecer fuente',
  'motion.textFx': 'Efecto de texto',
  'motion.textFxHint':
    'El efecto pasa a ser parte de esta capa: mismo texto, fuente y color, la capa solo se anima distinto. Su barra está en la fila de la capa en la línea de tiempo.',
  'motion.textFxApply': 'Aplicar',
  'motion.poster': 'Portada (miniatura e imagen)',
  'motion.textFxUntilEnd': '0 — mientras la capa esté en pantalla',
  'motion.textFxRemove': 'Quitar el efecto',
  'motion.generator': 'Generador de movimiento',
  'motion.generatorHint':
    'Trayectorias, física y ruido se escriben como claves desde el cabezal, editables una a una.',
  'motion.genDistance': 'Amplitud',
  'motion.genAngle': 'Ángulo',
  'motion.genGrow': 'Crecer, %',
  'motion.genCycles': 'Ciclos',
  'motion.genLength': 'Duración',
  'motion.genDirection': 'Hacia',
  'motion.genOrient': 'Girar según la trayectoria',
  'motion.genApply': 'Escribir claves',
  'motion.repeater': 'Repetir capa',
  'motion.repeaterHint':
    'Copias en cuadrícula, anillo, línea, espiral o dispersas, cada una empieza un poco después.',
  'motion.repeatLayout': 'Disposición',
  'motion.repeat_grid': 'Cuadrícula',
  'motion.repeat_circle': 'Círculo',
  'motion.repeat_line': 'Línea',
  'motion.repeat_spiral': 'Espiral',
  'motion.repeat_scatter': 'Dispersión',
  'motion.repeatCount': 'Cantidad',
  'motion.repeatCols': 'Por fila',
  'motion.repeatRadius': 'Radio',
  'motion.repeatAngle': 'Ángulo',
  'motion.repeatGap': 'Espacio',
  'motion.repeatStagger': 'Desfase',
  'motion.repeatRotate': 'Giro',
  'motion.repeatScale': 'Tamaño',
  'motion.repeatOpacity': 'Opacidad',
  'motion.repeatOrient': 'Mirar hacia fuera',
  'motion.repeatApply': 'Crear copias ({n})',
  'motion.fxcat_interface': 'Interfaz y datos',
  'motion.fxcat_pattern': 'Patrones y partículas',
  'motion.cost': 'Los vídeos tardan más que las imágenes, normalmente 10–30 segundos.',
};
